function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProvider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-77"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M631.73,238.66A91.55,91.55,0,0,0,617.46,215c-37.8-44.66-99.84-31.25-170.37-78.74-77.3-52-87.53-86.88-176.2-97.33C76.57,23.88,99.09,275.55,168.07,346.81c1.87,1.94,3.71,3.91,5.48,5.93,12.2,13.95,66.25,70.7,149.7,86.13C463,462.49,702.33,406.15,631.73,238.66Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.73,238.66A91.55,91.55,0,0,0,617.46,215c-37.8-44.66-99.84-31.25-170.37-78.74-77.3-52-87.53-86.88-176.2-97.33C76.57,23.88,99.09,275.55,168.07,346.81c1.87,1.94,3.71,3.91,5.48,5.93,12.2,13.95,66.25,70.7,149.7,86.13C463,462.49,702.33,406.15,631.73,238.66Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shelves--inject-77"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 185.26,
    y: 87.27,
    width: 26.12,
    height: 54.17,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.39,
    y: 97.34,
    width: 19.96,
    height: 5.76,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190.37,
    y1: 97.42,
    x2: 190.37,
    y2: 103.13,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 193.03,
    y1: 97.42,
    x2: 193.03,
    y2: 103.13,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195.69,
    y1: 97.42,
    x2: 195.69,
    y2: 103.13,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 198.35,
    y1: 97.42,
    x2: 198.35,
    y2: 103.13,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 201.01,
    y1: 97.42,
    x2: 201.01,
    y2: 103.13,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 203.67,
    y1: 97.42,
    x2: 203.67,
    y2: 103.13,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 206.33,
    y1: 97.42,
    x2: 206.33,
    y2: 103.13,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.39,128.16s-.43-4.24,7-7.61,16.69-8.49,18.74-14.79",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.08,80.54h.82A4.12,4.12,0,0,1,203,84.67v2.47a0,0,0,0,1,0,0H194a0,0,0,0,1,0,0V84.67A4.12,4.12,0,0,1,198.08,80.54Z",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.49,
    cy: 83.76,
    r: 1.4,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.33,
    y: 87.27,
    width: 26.12,
    height: 54.17,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.46,
    y: 97.34,
    width: 19.96,
    height: 5.76,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 224.44,
    y1: 97.42,
    x2: 224.44,
    y2: 103.13,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 227.1,
    y1: 97.42,
    x2: 227.1,
    y2: 103.13,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.76,
    y1: 97.42,
    x2: 229.76,
    y2: 103.13,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.42,
    y1: 97.42,
    x2: 232.42,
    y2: 103.13,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 235.08,
    y1: 97.42,
    x2: 235.08,
    y2: 103.13,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 237.74,
    y1: 97.42,
    x2: 237.74,
    y2: 103.13,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240.4,
    y1: 97.42,
    x2: 240.4,
    y2: 103.13,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.47,128.16s-.44-4.24,7-7.61,16.69-8.49,18.74-14.79",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.15,80.54H233a4.12,4.12,0,0,1,4.12,4.12v2.47a0,0,0,0,1,0,0H228a0,0,0,0,1,0,0V84.67A4.12,4.12,0,0,1,232.15,80.54Z",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,83.76a1.41,1.41,0,1,1-1.41-1.4A1.41,1.41,0,0,1,234,83.76Z",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.41,
    y: 87.27,
    width: 26.12,
    height: 54.17,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.53,
    y: 97.34,
    width: 19.96,
    height: 5.76,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 258.51,
    y1: 97.42,
    x2: 258.51,
    y2: 103.13,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 261.17,
    y1: 97.42,
    x2: 261.17,
    y2: 103.13,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 263.83,
    y1: 97.42,
    x2: 263.83,
    y2: 103.13,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266.49,
    y1: 97.42,
    x2: 266.49,
    y2: 103.13,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 269.15,
    y1: 97.42,
    x2: 269.15,
    y2: 103.13,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 271.81,
    y1: 97.42,
    x2: 271.81,
    y2: 103.13,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 274.47,
    y1: 97.42,
    x2: 274.47,
    y2: 103.13,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.54,128.16s-.44-4.24,7-7.61,16.69-8.49,18.74-14.79",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.22,80.54H267a4.12,4.12,0,0,1,4.12,4.12v2.47a0,0,0,0,1,0,0H262.1a0,0,0,0,1,0,0V84.67A4.12,4.12,0,0,1,266.22,80.54Z",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 266.63,
    cy: 83.76,
    r: 1.4,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.48,
    y: 87.27,
    width: 26.12,
    height: 54.17,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.6,
    y: 97.34,
    width: 19.96,
    height: 5.76,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 292.58,
    y1: 97.42,
    x2: 292.58,
    y2: 103.13,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 295.24,
    y1: 97.42,
    x2: 295.24,
    y2: 103.13,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 297.9,
    y1: 97.42,
    x2: 297.9,
    y2: 103.13,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300.56,
    y1: 97.42,
    x2: 300.56,
    y2: 103.13,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 303.22,
    y1: 97.42,
    x2: 303.22,
    y2: 103.13,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 305.88,
    y1: 97.42,
    x2: 305.88,
    y2: 103.13,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 308.54,
    y1: 97.42,
    x2: 308.54,
    y2: 103.13,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.61,128.16s-.44-4.24,7-7.61,16.69-8.49,18.74-14.79",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.29,80.54h.82a4.12,4.12,0,0,1,4.12,4.12v2.47a0,0,0,0,1,0,0h-9.07a0,0,0,0,1,0,0V84.67a4.12,4.12,0,0,1,4.12-4.12Z",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300.7,
    cy: 83.76,
    r: 1.4,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.55,
    y: 87.27,
    width: 26.12,
    height: 54.17,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.67,
    y: 97.34,
    width: 19.96,
    height: 5.76,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 326.65,
    y1: 97.42,
    x2: 326.65,
    y2: 103.13,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 329.31,
    y1: 97.42,
    x2: 329.31,
    y2: 103.13,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 331.97,
    y1: 97.42,
    x2: 331.97,
    y2: 103.13,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 334.63,
    y1: 97.42,
    x2: 334.63,
    y2: 103.13,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 337.29,
    y1: 97.42,
    x2: 337.29,
    y2: 103.13,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.95,
    y1: 97.42,
    x2: 339.95,
    y2: 103.13,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 342.61,
    y1: 97.42,
    x2: 342.61,
    y2: 103.13,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.68,128.16s-.44-4.24,7-7.61,16.69-8.49,18.74-14.79",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.36,80.54h.82a4.12,4.12,0,0,1,4.12,4.12v2.47a0,0,0,0,1,0,0h-9.07a0,0,0,0,1,0,0V84.67A4.12,4.12,0,0,1,334.36,80.54Z",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334.77,
    cy: 83.76,
    r: 1.4,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.62,
    y: 87.27,
    width: 26.12,
    height: 54.17,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.74,
    y: 97.34,
    width: 19.96,
    height: 5.76,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360.72,
    y1: 97.42,
    x2: 360.72,
    y2: 103.13,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 363.38,
    y1: 97.42,
    x2: 363.38,
    y2: 103.13,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 366.04,
    y1: 97.42,
    x2: 366.04,
    y2: 103.13,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 368.7,
    y1: 97.42,
    x2: 368.7,
    y2: 103.13,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 371.36,
    y1: 97.42,
    x2: 371.36,
    y2: 103.13,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 374.02,
    y1: 97.42,
    x2: 374.02,
    y2: 103.13,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 376.68,
    y1: 97.42,
    x2: 376.68,
    y2: 103.13,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.75,128.16s-.44-4.24,7-7.61,16.69-8.49,18.74-14.79",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.43,80.54h.82a4.12,4.12,0,0,1,4.12,4.12v2.47a0,0,0,0,1,0,0h-9.07a0,0,0,0,1,0,0V84.67A4.12,4.12,0,0,1,368.43,80.54Z",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.25,83.76a1.41,1.41,0,1,1-1.4-1.4A1.4,1.4,0,0,1,370.25,83.76Z",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.26,
    y: 153.1,
    width: 26.12,
    height: 54.17,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.39,
    y: 163.17,
    width: 19.96,
    height: 5.76,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190.37,
    y1: 163.25,
    x2: 190.37,
    y2: 168.95,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 193.03,
    y1: 163.25,
    x2: 193.03,
    y2: 168.95,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195.69,
    y1: 163.25,
    x2: 195.69,
    y2: 168.95,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 198.35,
    y1: 163.25,
    x2: 198.35,
    y2: 168.95,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 201.01,
    y1: 163.25,
    x2: 201.01,
    y2: 168.95,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 203.67,
    y1: 163.25,
    x2: 203.67,
    y2: 168.95,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 206.33,
    y1: 163.25,
    x2: 206.33,
    y2: 168.95,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.39,194s-.43-4.25,7-7.62,16.69-8.49,18.74-14.78",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.08,146.37h.82a4.12,4.12,0,0,1,4.12,4.12V153a0,0,0,0,1,0,0H194a0,0,0,0,1,0,0v-2.47A4.12,4.12,0,0,1,198.08,146.37Z",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.49,
    cy: 149.58,
    r: 1.4,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.33,
    y: 153.1,
    width: 26.12,
    height: 54.17,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.46,
    y: 163.17,
    width: 19.96,
    height: 5.76,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 224.44,
    y1: 163.25,
    x2: 224.44,
    y2: 168.95,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 227.1,
    y1: 163.25,
    x2: 227.1,
    y2: 168.95,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.76,
    y1: 163.25,
    x2: 229.76,
    y2: 168.95,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.42,
    y1: 163.25,
    x2: 232.42,
    y2: 168.95,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 235.08,
    y1: 163.25,
    x2: 235.08,
    y2: 168.95,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 237.74,
    y1: 163.25,
    x2: 237.74,
    y2: 168.95,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240.4,
    y1: 163.25,
    x2: 240.4,
    y2: 168.95,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.47,194s-.44-4.25,7-7.62,16.69-8.49,18.74-14.78",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.15,146.37H233a4.12,4.12,0,0,1,4.12,4.12V153a0,0,0,0,1,0,0H228a0,0,0,0,1,0,0v-2.47A4.12,4.12,0,0,1,232.15,146.37Z",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,149.58a1.41,1.41,0,1,1-1.41-1.4A1.4,1.4,0,0,1,234,149.58Z",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.4,
    y: 225.59,
    width: 26.12,
    height: 52.48,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.22,218.86H198a4.12,4.12,0,0,1,4.12,4.12v2.47a0,0,0,0,1,0,0h-9.07a0,0,0,0,1,0,0V223A4.12,4.12,0,0,1,197.22,218.86Z",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 197.63,
    cy: 222.08,
    r: 1.4,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.97,
    y: 231.29,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.97 231.29 187.26 232.65 189.97 234 189.97 231.29",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.97,
    y: 235.19,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.97 235.19 187.26 236.55 189.97 237.9 189.97 235.19",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.97,
    y: 239.09,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.97 239.09 187.26 240.44 189.97 241.8 189.97 239.09",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.97,
    y: 242.99,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.97 242.99 187.26 244.34 189.97 245.7 189.97 242.99",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.97,
    y: 246.88,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.97 246.88 187.26 248.24 189.97 249.59 189.97 246.88",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.97,
    y: 250.78,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.97 250.78 187.26 252.14 189.97 253.49 189.97 250.78",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.97,
    y: 254.68,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.97 254.68 187.26 256.03 189.97 257.39 189.97 254.68",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.97,
    y: 258.58,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.97 258.58 187.26 259.93 189.97 261.29 189.97 258.58",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.97,
    y: 262.47,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.97 262.47 187.26 263.83 189.97 265.19 189.97 262.47",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.97,
    y: 266.37,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.97 266.37 187.26 267.73 189.97 269.08 189.97 266.37",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.97,
    y: 270.27,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.97 270.27 187.26 271.62 189.97 272.98 189.97 270.27",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.95,
    y: 225.59,
    width: 26.12,
    height: 52.48,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.77,218.86h.82a4.12,4.12,0,0,1,4.12,4.12v2.47a0,0,0,0,1,0,0h-9.07a0,0,0,0,1,0,0V223A4.12,4.12,0,0,1,231.77,218.86Z",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.18,
    cy: 222.08,
    r: 1.4,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.53,
    y: 231.29,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.53 231.29 221.81 232.65 224.53 234 224.53 231.29",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.53,
    y: 235.19,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.53 235.19 221.81 236.55 224.53 237.9 224.53 235.19",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.53,
    y: 239.09,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.53 239.09 221.81 240.44 224.53 241.8 224.53 239.09",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.53,
    y: 242.99,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.53 242.99 221.81 244.34 224.53 245.7 224.53 242.99",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.53,
    y: 246.88,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.53 246.88 221.81 248.24 224.53 249.59 224.53 246.88",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.53,
    y: 250.78,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.53 250.78 221.81 252.14 224.53 253.49 224.53 250.78",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.53,
    y: 254.68,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.53 254.68 221.81 256.03 224.53 257.39 224.53 254.68",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.53,
    y: 258.58,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.53 258.58 221.81 259.93 224.53 261.29 224.53 258.58",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.53,
    y: 262.47,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.53 262.47 221.81 263.83 224.53 265.19 224.53 262.47",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.53,
    y: 266.37,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.53 266.37 221.81 267.73 224.53 269.08 224.53 266.37",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.53,
    y: 270.27,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.53 270.27 221.81 271.62 224.53 272.98 224.53 270.27",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.5,
    y: 225.59,
    width: 26.12,
    height: 52.48,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.32,218.86h.82a4.12,4.12,0,0,1,4.12,4.12v2.47a0,0,0,0,1,0,0H262.2a0,0,0,0,1,0,0V223A4.12,4.12,0,0,1,266.32,218.86Z",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 266.73,
    cy: 222.08,
    r: 1.4,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.08,
    y: 231.29,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.08 231.29 256.37 232.65 259.08 234 259.08 231.29",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.08,
    y: 235.19,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.08 235.19 256.37 236.55 259.08 237.9 259.08 235.19",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.08,
    y: 239.09,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.08 239.09 256.37 240.44 259.08 241.8 259.08 239.09",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.08,
    y: 242.99,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.08 242.99 256.37 244.34 259.08 245.7 259.08 242.99",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.08,
    y: 246.88,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.08 246.88 256.37 248.24 259.08 249.59 259.08 246.88",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.08,
    y: 250.78,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.08 250.78 256.37 252.14 259.08 253.49 259.08 250.78",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.08,
    y: 254.68,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.08 254.68 256.37 256.03 259.08 257.39 259.08 254.68",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.08,
    y: 258.58,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.08 258.58 256.37 259.93 259.08 261.29 259.08 258.58",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.08,
    y: 262.47,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.08 262.47 256.37 263.83 259.08 265.19 259.08 262.47",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.08,
    y: 266.37,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.08 266.37 256.37 267.73 259.08 269.08 259.08 266.37",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.08,
    y: 270.27,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.08 270.27 256.37 271.62 259.08 272.98 259.08 270.27",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.06,
    y: 225.59,
    width: 26.12,
    height: 52.48,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.88,218.86h.82a4.12,4.12,0,0,1,4.12,4.12v2.47a0,0,0,0,1,0,0h-9.07a0,0,0,0,1,0,0V223a4.12,4.12,0,0,1,4.12-4.12Z",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.69,222.08a1.4,1.4,0,1,1-1.4-1.41A1.4,1.4,0,0,1,302.69,222.08Z",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.63,
    y: 231.29,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.63 231.29 290.92 232.65 293.63 234 293.63 231.29",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.63,
    y: 235.19,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.63 235.19 290.92 236.55 293.63 237.9 293.63 235.19",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.63,
    y: 239.09,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.63 239.09 290.92 240.44 293.63 241.8 293.63 239.09",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.63,
    y: 242.99,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.63 242.99 290.92 244.34 293.63 245.7 293.63 242.99",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.63,
    y: 246.88,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.63 246.88 290.92 248.24 293.63 249.59 293.63 246.88",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.63,
    y: 250.78,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.63 250.78 290.92 252.14 293.63 253.49 293.63 250.78",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.63,
    y: 254.68,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.63 254.68 290.92 256.03 293.63 257.39 293.63 254.68",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.63,
    y: 258.58,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.63 258.58 290.92 259.93 293.63 261.29 293.63 258.58",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.63,
    y: 262.47,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.63 262.47 290.92 263.83 293.63 265.19 293.63 262.47",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.63,
    y: 266.37,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.63 266.37 290.92 267.73 293.63 269.08 293.63 266.37",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.63,
    y: 270.27,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.63 270.27 290.92 271.62 293.63 272.98 293.63 270.27",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.61,
    y: 225.59,
    width: 26.12,
    height: 52.48,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.43,218.86h.82a4.12,4.12,0,0,1,4.12,4.12v2.47a0,0,0,0,1,0,0h-9.07a0,0,0,0,1,0,0V223A4.12,4.12,0,0,1,335.43,218.86Z",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.24,222.08a1.4,1.4,0,1,1-1.4-1.41A1.4,1.4,0,0,1,337.24,222.08Z",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.19,
    y: 231.29,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.19 231.29 325.48 232.65 328.19 234 328.19 231.29",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.19,
    y: 235.19,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.19 235.19 325.48 236.55 328.19 237.9 328.19 235.19",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.19,
    y: 239.09,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.19 239.09 325.48 240.44 328.19 241.8 328.19 239.09",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.19,
    y: 242.99,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.19 242.99 325.48 244.34 328.19 245.7 328.19 242.99",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.19,
    y: 246.88,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.19 246.88 325.48 248.24 328.19 249.59 328.19 246.88",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.19,
    y: 250.78,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.19 250.78 325.48 252.14 328.19 253.49 328.19 250.78",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.19,
    y: 254.68,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.19 254.68 325.48 256.03 328.19 257.39 328.19 254.68",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.19,
    y: 258.58,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.19 258.58 325.48 259.93 328.19 261.29 328.19 258.58",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.19,
    y: 262.47,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.19 262.47 325.48 263.83 328.19 265.19 328.19 262.47",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.19,
    y: 266.37,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.19 266.37 325.48 267.73 328.19 269.08 328.19 266.37",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.19,
    y: 270.27,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.19 270.27 325.48 271.62 328.19 272.98 328.19 270.27",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.17,
    y: 225.59,
    width: 26.12,
    height: 52.48,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370,218.86h.82a4.12,4.12,0,0,1,4.12,4.12v2.47a0,0,0,0,1,0,0h-9.07a0,0,0,0,1,0,0V223A4.12,4.12,0,0,1,370,218.86Z",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370.39,
    cy: 222.08,
    r: 1.4,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.74,
    y: 231.29,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.74 231.29 360.03 232.65 362.74 234 362.74 231.29",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.74,
    y: 235.19,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.74 235.19 360.03 236.55 362.74 237.9 362.74 235.19",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.74,
    y: 239.09,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.74 239.09 360.03 240.44 362.74 241.8 362.74 239.09",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.74,
    y: 242.99,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.74 242.99 360.03 244.34 362.74 245.7 362.74 242.99",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.74,
    y: 246.88,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.74 246.88 360.03 248.24 362.74 249.59 362.74 246.88",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.74,
    y: 250.78,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.74 250.78 360.03 252.14 362.74 253.49 362.74 250.78",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.74,
    y: 254.68,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.74 254.68 360.03 256.03 362.74 257.39 362.74 254.68",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.74,
    y: 258.58,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.74 258.58 360.03 259.93 362.74 261.29 362.74 258.58",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.74,
    y: 262.47,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.74 262.47 360.03 263.83 362.74 265.19 362.74 262.47",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.74,
    y: 266.37,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.74 266.37 360.03 267.73 362.74 269.08 362.74 266.37",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.74,
    y: 270.27,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.74 270.27 360.03 271.62 362.74 272.98 362.74 270.27",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.4,
    y: 291.68,
    width: 26.12,
    height: 52.48,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.22,285H198a4.12,4.12,0,0,1,4.12,4.12v2.47a0,0,0,0,1,0,0h-9.07a0,0,0,0,1,0,0v-2.47A4.12,4.12,0,0,1,197.22,285Z",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 197.63,
    cy: 288.17,
    r: 1.4,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.97,
    y: 297.39,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.97 297.39 187.26 298.74 189.97 300.1 189.97 297.39",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.97,
    y: 301.28,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.97 301.28 187.26 302.64 189.97 304 189.97 301.28",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.97,
    y: 305.18,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.97 305.18 187.26 306.54 189.97 307.89 189.97 305.18",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.97,
    y: 309.08,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.97 309.08 187.26 310.44 189.97 311.79 189.97 309.08",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.97,
    y: 312.98,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.97 312.98 187.26 314.33 189.97 315.69 189.97 312.98",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.97,
    y: 316.87,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.97 316.87 187.26 318.23 189.97 319.59 189.97 316.87",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.97,
    y: 320.77,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.97 320.77 187.26 322.13 189.97 323.48 189.97 320.77",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.97,
    y: 324.67,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.97 324.67 187.26 326.02 189.97 327.38 189.97 324.67",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.97,
    y: 328.57,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.97 328.57 187.26 329.92 189.97 331.28 189.97 328.57",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.97,
    y: 332.46,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.97 332.46 187.26 333.82 189.97 335.18 189.97 332.46",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.97,
    y: 336.36,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.97 336.36 187.26 337.72 189.97 339.07 189.97 336.36",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.95,
    y: 291.68,
    width: 26.12,
    height: 52.48,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.77,285h.82a4.12,4.12,0,0,1,4.12,4.12v2.47a0,0,0,0,1,0,0h-9.07a0,0,0,0,1,0,0v-2.47A4.12,4.12,0,0,1,231.77,285Z",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.18,
    cy: 288.17,
    r: 1.4,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.53,
    y: 297.39,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.53 297.39 221.81 298.74 224.53 300.1 224.53 297.39",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.53,
    y: 301.28,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.53 301.28 221.81 302.64 224.53 304 224.53 301.28",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.53,
    y: 305.18,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.53 305.18 221.81 306.54 224.53 307.89 224.53 305.18",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.53,
    y: 309.08,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.53 309.08 221.81 310.44 224.53 311.79 224.53 309.08",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.53,
    y: 312.98,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.53 312.98 221.81 314.33 224.53 315.69 224.53 312.98",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.53,
    y: 316.87,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.53 316.87 221.81 318.23 224.53 319.59 224.53 316.87",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.53,
    y: 320.77,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.53 320.77 221.81 322.13 224.53 323.48 224.53 320.77",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.53,
    y: 324.67,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.53 324.67 221.81 326.02 224.53 327.38 224.53 324.67",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.53,
    y: 328.57,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.53 328.57 221.81 329.92 224.53 331.28 224.53 328.57",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.53,
    y: 332.46,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.53 332.46 221.81 333.82 224.53 335.18 224.53 332.46",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.53,
    y: 336.36,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.53 336.36 221.81 337.72 224.53 339.07 224.53 336.36",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.5,
    y: 291.68,
    width: 26.12,
    height: 52.48,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.32,285h.82a4.12,4.12,0,0,1,4.12,4.12v2.47a0,0,0,0,1,0,0H262.2a0,0,0,0,1,0,0v-2.47A4.12,4.12,0,0,1,266.32,285Z",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 266.73,
    cy: 288.17,
    r: 1.4,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.08,
    y: 297.39,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.08 297.39 256.37 298.74 259.08 300.1 259.08 297.39",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.08,
    y: 301.28,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.08 301.28 256.37 302.64 259.08 304 259.08 301.28",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.08,
    y: 305.18,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.08 305.18 256.37 306.54 259.08 307.89 259.08 305.18",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.08,
    y: 309.08,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.08 309.08 256.37 310.44 259.08 311.79 259.08 309.08",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.08,
    y: 312.98,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.08 312.98 256.37 314.33 259.08 315.69 259.08 312.98",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.08,
    y: 316.87,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.08 316.87 256.37 318.23 259.08 319.59 259.08 316.87",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.08,
    y: 320.77,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.08 320.77 256.37 322.13 259.08 323.48 259.08 320.77",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.08,
    y: 324.67,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.08 324.67 256.37 326.02 259.08 327.38 259.08 324.67",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.08,
    y: 328.57,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.08 328.57 256.37 329.92 259.08 331.28 259.08 328.57",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.08,
    y: 332.46,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.08 332.46 256.37 333.82 259.08 335.18 259.08 332.46",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.08,
    y: 336.36,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.08 336.36 256.37 337.72 259.08 339.07 259.08 336.36",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.06,
    y: 291.68,
    width: 26.12,
    height: 52.48,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.88,285h.82a4.12,4.12,0,0,1,4.12,4.12v2.47a0,0,0,0,1,0,0h-9.07a0,0,0,0,1,0,0v-2.47A4.12,4.12,0,0,1,300.88,285Z",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.69,288.17a1.4,1.4,0,1,1-1.4-1.4A1.4,1.4,0,0,1,302.69,288.17Z",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.63,
    y: 297.39,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.63 297.39 290.92 298.74 293.63 300.1 293.63 297.39",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.63,
    y: 301.28,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.63 301.28 290.92 302.64 293.63 304 293.63 301.28",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.63,
    y: 305.18,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.63 305.18 290.92 306.54 293.63 307.89 293.63 305.18",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.63,
    y: 309.08,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.63 309.08 290.92 310.44 293.63 311.79 293.63 309.08",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.63,
    y: 312.98,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.63 312.98 290.92 314.33 293.63 315.69 293.63 312.98",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.63,
    y: 316.87,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.63 316.87 290.92 318.23 293.63 319.59 293.63 316.87",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.63,
    y: 320.77,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.63 320.77 290.92 322.13 293.63 323.48 293.63 320.77",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.63,
    y: 324.67,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.63 324.67 290.92 326.02 293.63 327.38 293.63 324.67",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.63,
    y: 328.57,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.63 328.57 290.92 329.92 293.63 331.28 293.63 328.57",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.63,
    y: 332.46,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.63 332.46 290.92 333.82 293.63 335.18 293.63 332.46",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.63,
    y: 336.36,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.63 336.36 290.92 337.72 293.63 339.07 293.63 336.36",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.61,
    y: 291.68,
    width: 26.12,
    height: 52.48,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.43,285h.82a4.12,4.12,0,0,1,4.12,4.12v2.47a0,0,0,0,1,0,0h-9.07a0,0,0,0,1,0,0v-2.47A4.12,4.12,0,0,1,335.43,285Z",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.24,288.17a1.4,1.4,0,1,1-1.4-1.4A1.4,1.4,0,0,1,337.24,288.17Z",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.19,
    y: 297.39,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.19 297.39 325.48 298.74 328.19 300.1 328.19 297.39",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.19,
    y: 301.28,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.19 301.28 325.48 302.64 328.19 304 328.19 301.28",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.19,
    y: 305.18,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.19 305.18 325.48 306.54 328.19 307.89 328.19 305.18",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.19,
    y: 309.08,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.19 309.08 325.48 310.44 328.19 311.79 328.19 309.08",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.19,
    y: 312.98,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.19 312.98 325.48 314.33 328.19 315.69 328.19 312.98",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.19,
    y: 316.87,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.19 316.87 325.48 318.23 328.19 319.59 328.19 316.87",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.19,
    y: 320.77,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.19 320.77 325.48 322.13 328.19 323.48 328.19 320.77",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.19,
    y: 324.67,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.19 324.67 325.48 326.02 328.19 327.38 328.19 324.67",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.19,
    y: 328.57,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.19 328.57 325.48 329.92 328.19 331.28 328.19 328.57",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.19,
    y: 332.46,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.19 332.46 325.48 333.82 328.19 335.18 328.19 332.46",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.19,
    y: 336.36,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.19 336.36 325.48 337.72 328.19 339.07 328.19 336.36",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.17,
    y: 291.68,
    width: 26.12,
    height: 52.48,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370,285h.82a4.12,4.12,0,0,1,4.12,4.12v2.47a0,0,0,0,1,0,0h-9.07a0,0,0,0,1,0,0v-2.47A4.12,4.12,0,0,1,370,285Z",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370.39,
    cy: 288.17,
    r: 1.4,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.74,
    y: 297.39,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.74 297.39 360.03 298.74 362.74 300.1 362.74 297.39",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.74,
    y: 301.28,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.74 301.28 360.03 302.64 362.74 304 362.74 301.28",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.74,
    y: 305.18,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.74 305.18 360.03 306.54 362.74 307.89 362.74 305.18",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.74,
    y: 309.08,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.74 309.08 360.03 310.44 362.74 311.79 362.74 309.08",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.74,
    y: 312.98,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.74 312.98 360.03 314.33 362.74 315.69 362.74 312.98",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.74,
    y: 316.87,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.74 316.87 360.03 318.23 362.74 319.59 362.74 316.87",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.74,
    y: 320.77,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.74 320.77 360.03 322.13 362.74 323.48 362.74 320.77",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.74,
    y: 324.67,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.74 324.67 360.03 326.02 362.74 327.38 362.74 324.67",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.74,
    y: 328.57,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.74 328.57 360.03 329.92 362.74 331.28 362.74 328.57",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.74,
    y: 332.46,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.74 332.46 360.03 333.82 362.74 335.18 362.74 332.46",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.74,
    y: 336.36,
    width: 16.95,
    height: 2.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.74 336.36 360.03 337.72 362.74 339.07 362.74 336.36",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.41,
    y: 153.1,
    width: 26.12,
    height: 54.17,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.53,
    y: 163.17,
    width: 19.96,
    height: 5.76,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 258.51,
    y1: 163.25,
    x2: 258.51,
    y2: 168.95,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 261.17,
    y1: 163.25,
    x2: 261.17,
    y2: 168.95,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 263.83,
    y1: 163.25,
    x2: 263.83,
    y2: 168.95,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266.49,
    y1: 163.25,
    x2: 266.49,
    y2: 168.95,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 269.15,
    y1: 163.25,
    x2: 269.15,
    y2: 168.95,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 271.81,
    y1: 163.25,
    x2: 271.81,
    y2: 168.95,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 274.47,
    y1: 163.25,
    x2: 274.47,
    y2: 168.95,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.54,194s-.44-4.25,7-7.62,16.69-8.49,18.74-14.78",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.22,146.37H267a4.12,4.12,0,0,1,4.12,4.12V153a0,0,0,0,1,0,0H262.1a0,0,0,0,1,0,0v-2.47A4.12,4.12,0,0,1,266.22,146.37Z",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 266.63,
    cy: 149.58,
    r: 1.4,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.48,
    y: 153.1,
    width: 26.12,
    height: 54.17,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.6,
    y: 163.17,
    width: 19.96,
    height: 5.76,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 292.58,
    y1: 163.25,
    x2: 292.58,
    y2: 168.95,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 295.24,
    y1: 163.25,
    x2: 295.24,
    y2: 168.95,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 297.9,
    y1: 163.25,
    x2: 297.9,
    y2: 168.95,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300.56,
    y1: 163.25,
    x2: 300.56,
    y2: 168.95,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 303.22,
    y1: 163.25,
    x2: 303.22,
    y2: 168.95,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 305.88,
    y1: 163.25,
    x2: 305.88,
    y2: 168.95,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 308.54,
    y1: 163.25,
    x2: 308.54,
    y2: 168.95,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.61,194s-.44-4.25,7-7.62,16.69-8.49,18.74-14.78",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.29,146.37h.82a4.12,4.12,0,0,1,4.12,4.12V153a0,0,0,0,1,0,0h-9.07a0,0,0,0,1,0,0v-2.47a4.12,4.12,0,0,1,4.12-4.12Z",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300.7,
    cy: 149.58,
    r: 1.4,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.55,
    y: 153.1,
    width: 26.12,
    height: 54.17,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.67,
    y: 163.17,
    width: 19.96,
    height: 5.76,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 326.65,
    y1: 163.25,
    x2: 326.65,
    y2: 168.95,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 329.31,
    y1: 163.25,
    x2: 329.31,
    y2: 168.95,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 331.97,
    y1: 163.25,
    x2: 331.97,
    y2: 168.95,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 334.63,
    y1: 163.25,
    x2: 334.63,
    y2: 168.95,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 337.29,
    y1: 163.25,
    x2: 337.29,
    y2: 168.95,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.95,
    y1: 163.25,
    x2: 339.95,
    y2: 168.95,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 342.61,
    y1: 163.25,
    x2: 342.61,
    y2: 168.95,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.68,194s-.44-4.25,7-7.62,16.69-8.49,18.74-14.78",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.36,146.37h.82a4.12,4.12,0,0,1,4.12,4.12V153a0,0,0,0,1,0,0h-9.07a0,0,0,0,1,0,0v-2.47A4.12,4.12,0,0,1,334.36,146.37Z",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334.77,
    cy: 149.58,
    r: 1.4,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.62,
    y: 153.1,
    width: 26.12,
    height: 54.17,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.74,
    y: 163.17,
    width: 19.96,
    height: 5.76,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360.72,
    y1: 163.25,
    x2: 360.72,
    y2: 168.95,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 363.38,
    y1: 163.25,
    x2: 363.38,
    y2: 168.95,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 366.04,
    y1: 163.25,
    x2: 366.04,
    y2: 168.95,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 368.7,
    y1: 163.25,
    x2: 368.7,
    y2: 168.95,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 371.36,
    y1: 163.25,
    x2: 371.36,
    y2: 168.95,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 374.02,
    y1: 163.25,
    x2: 374.02,
    y2: 168.95,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 376.68,
    y1: 163.25,
    x2: 376.68,
    y2: 168.95,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.75,194s-.44-4.25,7-7.62,16.69-8.49,18.74-14.78",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.43,146.37h.82a4.12,4.12,0,0,1,4.12,4.12V153a0,0,0,0,1,0,0h-9.07a0,0,0,0,1,0,0v-2.47A4.12,4.12,0,0,1,368.43,146.37Z",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.25,149.58a1.41,1.41,0,1,1-1.4-1.4A1.4,1.4,0,0,1,370.25,149.58Z",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.26,
    y: 355.97,
    width: 26.12,
    height: 54.17,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.39,
    y: 366.04,
    width: 19.96,
    height: 5.76,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190.37,
    y1: 366.12,
    x2: 190.37,
    y2: 371.83,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 193.03,
    y1: 366.12,
    x2: 193.03,
    y2: 371.83,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195.69,
    y1: 366.12,
    x2: 195.69,
    y2: 371.83,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 198.35,
    y1: 366.12,
    x2: 198.35,
    y2: 371.83,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 201.01,
    y1: 366.12,
    x2: 201.01,
    y2: 371.83,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 203.67,
    y1: 366.12,
    x2: 203.67,
    y2: 371.83,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 206.33,
    y1: 366.12,
    x2: 206.33,
    y2: 371.83,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.39,396.86s-.43-4.25,7-7.61,16.69-8.49,18.74-14.79",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.08,349.24h.82a4.12,4.12,0,0,1,4.12,4.12v2.47a0,0,0,0,1,0,0H194a0,0,0,0,1,0,0v-2.47A4.12,4.12,0,0,1,198.08,349.24Z",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.49,
    cy: 352.46,
    r: 1.4,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.33,
    y: 355.97,
    width: 26.12,
    height: 54.17,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.46,
    y: 366.04,
    width: 19.96,
    height: 5.76,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 224.44,
    y1: 366.12,
    x2: 224.44,
    y2: 371.83,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 227.1,
    y1: 366.12,
    x2: 227.1,
    y2: 371.83,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.76,
    y1: 366.12,
    x2: 229.76,
    y2: 371.83,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.42,
    y1: 366.12,
    x2: 232.42,
    y2: 371.83,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 235.08,
    y1: 366.12,
    x2: 235.08,
    y2: 371.83,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 237.74,
    y1: 366.12,
    x2: 237.74,
    y2: 371.83,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240.4,
    y1: 366.12,
    x2: 240.4,
    y2: 371.83,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.47,396.86s-.44-4.25,7-7.61,16.69-8.49,18.74-14.79",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.15,349.24H233a4.12,4.12,0,0,1,4.12,4.12v2.47a0,0,0,0,1,0,0H228a0,0,0,0,1,0,0v-2.47A4.12,4.12,0,0,1,232.15,349.24Z",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,352.46a1.41,1.41,0,1,1-1.41-1.41A1.41,1.41,0,0,1,234,352.46Z",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.41,
    y: 355.97,
    width: 26.12,
    height: 54.17,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.53,
    y: 366.04,
    width: 19.96,
    height: 5.76,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 258.51,
    y1: 366.12,
    x2: 258.51,
    y2: 371.83,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 261.17,
    y1: 366.12,
    x2: 261.17,
    y2: 371.83,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 263.83,
    y1: 366.12,
    x2: 263.83,
    y2: 371.83,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266.49,
    y1: 366.12,
    x2: 266.49,
    y2: 371.83,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 269.15,
    y1: 366.12,
    x2: 269.15,
    y2: 371.83,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 271.81,
    y1: 366.12,
    x2: 271.81,
    y2: 371.83,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 274.47,
    y1: 366.12,
    x2: 274.47,
    y2: 371.83,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.54,396.86s-.44-4.25,7-7.61,16.69-8.49,18.74-14.79",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.22,349.24H267a4.12,4.12,0,0,1,4.12,4.12v2.47a0,0,0,0,1,0,0H262.1a0,0,0,0,1,0,0v-2.47A4.12,4.12,0,0,1,266.22,349.24Z",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 266.63,
    cy: 352.46,
    r: 1.4,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.48,
    y: 355.97,
    width: 26.12,
    height: 54.17,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.6,
    y: 366.04,
    width: 19.96,
    height: 5.76,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 292.58,
    y1: 366.12,
    x2: 292.58,
    y2: 371.83,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 295.24,
    y1: 366.12,
    x2: 295.24,
    y2: 371.83,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 297.9,
    y1: 366.12,
    x2: 297.9,
    y2: 371.83,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300.56,
    y1: 366.12,
    x2: 300.56,
    y2: 371.83,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 303.22,
    y1: 366.12,
    x2: 303.22,
    y2: 371.83,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 305.88,
    y1: 366.12,
    x2: 305.88,
    y2: 371.83,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 308.54,
    y1: 366.12,
    x2: 308.54,
    y2: 371.83,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.61,396.86s-.44-4.25,7-7.61,16.69-8.49,18.74-14.79",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.29,349.24h.82a4.12,4.12,0,0,1,4.12,4.12v2.47a0,0,0,0,1,0,0h-9.07a0,0,0,0,1,0,0v-2.47A4.12,4.12,0,0,1,300.29,349.24Z",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300.7,
    cy: 352.46,
    r: 1.4,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.55,
    y: 355.97,
    width: 26.12,
    height: 54.17,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.67,
    y: 366.04,
    width: 19.96,
    height: 5.76,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 326.65,
    y1: 366.12,
    x2: 326.65,
    y2: 371.83,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 329.31,
    y1: 366.12,
    x2: 329.31,
    y2: 371.83,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 331.97,
    y1: 366.12,
    x2: 331.97,
    y2: 371.83,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 334.63,
    y1: 366.12,
    x2: 334.63,
    y2: 371.83,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 337.29,
    y1: 366.12,
    x2: 337.29,
    y2: 371.83,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.95,
    y1: 366.12,
    x2: 339.95,
    y2: 371.83,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 342.61,
    y1: 366.12,
    x2: 342.61,
    y2: 371.83,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.68,396.86s-.44-4.25,7-7.61,16.69-8.49,18.74-14.79",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.36,349.24h.82a4.12,4.12,0,0,1,4.12,4.12v2.47a0,0,0,0,1,0,0h-9.07a0,0,0,0,1,0,0v-2.47A4.12,4.12,0,0,1,334.36,349.24Z",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334.77,
    cy: 352.46,
    r: 1.4,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.62,
    y: 355.97,
    width: 26.12,
    height: 54.17,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.74,
    y: 366.04,
    width: 19.96,
    height: 5.76,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360.72,
    y1: 366.12,
    x2: 360.72,
    y2: 371.83,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 363.38,
    y1: 366.12,
    x2: 363.38,
    y2: 371.83,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 366.04,
    y1: 366.12,
    x2: 366.04,
    y2: 371.83,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 368.7,
    y1: 366.12,
    x2: 368.7,
    y2: 371.83,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 371.36,
    y1: 366.12,
    x2: 371.36,
    y2: 371.83,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 374.02,
    y1: 366.12,
    x2: 374.02,
    y2: 371.83,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 376.68,
    y1: 366.12,
    x2: 376.68,
    y2: 371.83,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.75,396.86s-.44-4.25,7-7.61,16.69-8.49,18.74-14.79",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.43,349.24h.82a4.12,4.12,0,0,1,4.12,4.12v2.47a0,0,0,0,1,0,0h-9.07a0,0,0,0,1,0,0v-2.47A4.12,4.12,0,0,1,368.43,349.24Z",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.25,352.46a1.41,1.41,0,1,1-1.4-1.41A1.4,1.4,0,0,1,370.25,352.46Z",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 392.47,
    y1: 78.39,
    x2: 392.47,
    y2: 468.58,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 393.11,
    y1: 128.76,
    x2: 593.94,
    y2: 128.76,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 393.11,
    y1: 139.6,
    x2: 593.94,
    y2: 139.6,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 393.11,
    y1: 214.19,
    x2: 593.94,
    y2: 214.19,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 393.11,
    y1: 225.03,
    x2: 593.94,
    y2: 225.03,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 393.11,
    y1: 299.62,
    x2: 593.94,
    y2: 299.62,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 393.11,
    y1: 310.46,
    x2: 593.94,
    y2: 310.46,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 393.11,
    y1: 385.06,
    x2: 593.94,
    y2: 385.06,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 393.11,
    y1: 395.9,
    x2: 593.94,
    y2: 395.9,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "440.85 78.84 400.67 78.84 402.05 128.3 440.85 128.3 440.85 78.84",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.22,
    y1: 81.27,
    x2: 399.06,
    y2: 81.66,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.16,
    y1: 85.35,
    x2: 399,
    y2: 85.74,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.1,
    y1: 89.43,
    x2: 398.95,
    y2: 89.82,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.05,
    y1: 93.51,
    x2: 398.89,
    y2: 93.9,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 402.99,
    y1: 97.59,
    x2: 398.83,
    y2: 97.98,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 402.93,
    y1: 101.68,
    x2: 398.77,
    y2: 102.06,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 402.87,
    y1: 105.76,
    x2: 398.72,
    y2: 106.14,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 402.82,
    y1: 109.84,
    x2: 398.66,
    y2: 110.22,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 402.76,
    y1: 113.92,
    x2: 398.6,
    y2: 114.31,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 402.7,
    y1: 118,
    x2: 398.54,
    y2: 118.39,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 402.65,
    y1: 122.08,
    x2: 398.49,
    y2: 122.47,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 402.59,
    y1: 126.16,
    x2: 398.43,
    y2: 126.55,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "485.56 78.84 445.38 78.84 446.76 128.3 485.56 128.3 485.56 78.84",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 447.93,
    y1: 81.27,
    x2: 443.77,
    y2: 81.66,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 447.87,
    y1: 85.35,
    x2: 443.71,
    y2: 85.74,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 447.82,
    y1: 89.43,
    x2: 443.66,
    y2: 89.82,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 447.76,
    y1: 93.51,
    x2: 443.6,
    y2: 93.9,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 447.7,
    y1: 97.59,
    x2: 443.54,
    y2: 97.98,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 447.64,
    y1: 101.68,
    x2: 443.48,
    y2: 102.06,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 447.59,
    y1: 105.76,
    x2: 443.43,
    y2: 106.14,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 447.53,
    y1: 109.84,
    x2: 443.37,
    y2: 110.22,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 447.47,
    y1: 113.92,
    x2: 443.31,
    y2: 114.31,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 447.41,
    y1: 118,
    x2: 443.26,
    y2: 118.39,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 447.36,
    y1: 122.08,
    x2: 443.2,
    y2: 122.47,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 447.3,
    y1: 126.16,
    x2: 443.14,
    y2: 126.55,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "530.27 78.84 490.09 78.84 491.47 128.3 530.27 128.3 530.27 78.84",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 492.64,
    y1: 81.27,
    x2: 488.48,
    y2: 81.66,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 492.58,
    y1: 85.35,
    x2: 488.43,
    y2: 85.74,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 492.53,
    y1: 89.43,
    x2: 488.37,
    y2: 89.82,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 492.47,
    y1: 93.51,
    x2: 488.31,
    y2: 93.9,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 492.41,
    y1: 97.59,
    x2: 488.25,
    y2: 97.98,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 492.35,
    y1: 101.68,
    x2: 488.2,
    y2: 102.06,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 492.3,
    y1: 105.76,
    x2: 488.14,
    y2: 106.14,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 492.24,
    y1: 109.84,
    x2: 488.08,
    y2: 110.22,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 492.18,
    y1: 113.92,
    x2: 488.02,
    y2: 114.31,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 492.13,
    y1: 118,
    x2: 487.97,
    y2: 118.39,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 492.07,
    y1: 122.08,
    x2: 487.91,
    y2: 122.47,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 492.01,
    y1: 126.16,
    x2: 487.85,
    y2: 126.55,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "574.98 78.84 534.8 78.84 536.18 128.3 574.98 128.3 574.98 78.84",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 537.35,
    y1: 81.27,
    x2: 533.19,
    y2: 81.66,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 537.3,
    y1: 85.35,
    x2: 533.14,
    y2: 85.74,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 537.24,
    y1: 89.43,
    x2: 533.08,
    y2: 89.82,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 537.18,
    y1: 93.51,
    x2: 533.02,
    y2: 93.9,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 537.12,
    y1: 97.59,
    x2: 532.96,
    y2: 97.98,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 537.07,
    y1: 101.68,
    x2: 532.91,
    y2: 102.06,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 537.01,
    y1: 105.76,
    x2: 532.85,
    y2: 106.14,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 536.95,
    y1: 109.84,
    x2: 532.79,
    y2: 110.22,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 536.89,
    y1: 113.92,
    x2: 532.74,
    y2: 114.31,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 536.84,
    y1: 118,
    x2: 532.68,
    y2: 118.39,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 536.78,
    y1: 122.08,
    x2: 532.62,
    y2: 122.47,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 536.72,
    y1: 126.16,
    x2: 532.56,
    y2: 126.55,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "440.85 164.6 400.67 164.6 402.05 214.06 440.85 214.06 440.85 164.6",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.22,
    y1: 167.03,
    x2: 399.06,
    y2: 167.41,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.16,
    y1: 171.11,
    x2: 399,
    y2: 171.5,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.1,
    y1: 175.19,
    x2: 398.95,
    y2: 175.58,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.05,
    y1: 179.27,
    x2: 398.89,
    y2: 179.66,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 402.99,
    y1: 183.35,
    x2: 398.83,
    y2: 183.74,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 402.93,
    y1: 187.43,
    x2: 398.77,
    y2: 187.82,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 402.87,
    y1: 191.52,
    x2: 398.72,
    y2: 191.9,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 402.82,
    y1: 195.6,
    x2: 398.66,
    y2: 195.98,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 402.76,
    y1: 199.68,
    x2: 398.6,
    y2: 200.06,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 402.7,
    y1: 203.76,
    x2: 398.54,
    y2: 204.15,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 402.65,
    y1: 207.84,
    x2: 398.49,
    y2: 208.23,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 402.59,
    y1: 211.92,
    x2: 398.43,
    y2: 212.31,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "485.56 164.6 445.38 164.6 446.76 214.06 485.56 214.06 485.56 164.6",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 447.93,
    y1: 167.03,
    x2: 443.77,
    y2: 167.41,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 447.87,
    y1: 171.11,
    x2: 443.71,
    y2: 171.5,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 447.82,
    y1: 175.19,
    x2: 443.66,
    y2: 175.58,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 447.76,
    y1: 179.27,
    x2: 443.6,
    y2: 179.66,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 447.7,
    y1: 183.35,
    x2: 443.54,
    y2: 183.74,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 447.64,
    y1: 187.43,
    x2: 443.48,
    y2: 187.82,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 447.59,
    y1: 191.52,
    x2: 443.43,
    y2: 191.9,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 447.53,
    y1: 195.6,
    x2: 443.37,
    y2: 195.98,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 447.47,
    y1: 199.68,
    x2: 443.31,
    y2: 200.06,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 447.41,
    y1: 203.76,
    x2: 443.26,
    y2: 204.15,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 447.36,
    y1: 207.84,
    x2: 443.2,
    y2: 208.23,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 447.3,
    y1: 211.92,
    x2: 443.14,
    y2: 212.31,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "530.27 164.6 490.09 164.6 491.47 214.06 530.27 214.06 530.27 164.6",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 492.64,
    y1: 167.03,
    x2: 488.48,
    y2: 167.41,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 492.58,
    y1: 171.11,
    x2: 488.43,
    y2: 171.5,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 492.53,
    y1: 175.19,
    x2: 488.37,
    y2: 175.58,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 492.47,
    y1: 179.27,
    x2: 488.31,
    y2: 179.66,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 492.41,
    y1: 183.35,
    x2: 488.25,
    y2: 183.74,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 492.35,
    y1: 187.43,
    x2: 488.2,
    y2: 187.82,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 492.3,
    y1: 191.52,
    x2: 488.14,
    y2: 191.9,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 492.24,
    y1: 195.6,
    x2: 488.08,
    y2: 195.98,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 492.18,
    y1: 199.68,
    x2: 488.02,
    y2: 200.06,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 492.13,
    y1: 203.76,
    x2: 487.97,
    y2: 204.15,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 492.07,
    y1: 207.84,
    x2: 487.91,
    y2: 208.23,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 492.01,
    y1: 211.92,
    x2: 487.85,
    y2: 212.31,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "574.98 164.6 534.8 164.6 536.18 214.06 574.98 214.06 574.98 164.6",
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 537.35,
    y1: 167.03,
    x2: 533.19,
    y2: 167.41,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 537.3,
    y1: 171.11,
    x2: 533.14,
    y2: 171.5,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 537.24,
    y1: 175.19,
    x2: 533.08,
    y2: 175.58,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 537.18,
    y1: 179.27,
    x2: 533.02,
    y2: 179.66,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 537.12,
    y1: 183.35,
    x2: 532.96,
    y2: 183.74,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 537.07,
    y1: 187.43,
    x2: 532.91,
    y2: 187.82,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 537.01,
    y1: 191.52,
    x2: 532.85,
    y2: 191.9,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 536.95,
    y1: 195.6,
    x2: 532.79,
    y2: 195.98,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 536.89,
    y1: 199.68,
    x2: 532.74,
    y2: 200.06,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 536.84,
    y1: 203.76,
    x2: 532.68,
    y2: 204.15,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 536.78,
    y1: 207.84,
    x2: 532.62,
    y2: 208.23,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 536.72,
    y1: 211.92,
    x2: 532.56,
    y2: 212.31,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9339074388140602px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.66,
    y: 235.15,
    width: 16.96,
    height: 64.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.01,
    y: 256.13,
    width: 5.8,
    height: 28.11,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.19,
    y: 235.15,
    width: 16.96,
    height: 64.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.54,
    y: 256.13,
    width: 5.8,
    height: 28.11,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 437.71,
    y: 235.15,
    width: 16.96,
    height: 64.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.07,
    y: 256.13,
    width: 5.8,
    height: 28.11,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.24,
    y: 235.15,
    width: 16.96,
    height: 64.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 463.6,
    y: 256.13,
    width: 5.8,
    height: 28.11,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 478.77,
    y: 235.15,
    width: 16.96,
    height: 64.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 484.12,
    y: 256.13,
    width: 5.8,
    height: 28.11,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499.3,
    y: 235.15,
    width: 16.96,
    height: 64.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504.65,
    y: 256.13,
    width: 5.8,
    height: 28.11,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 519.82,
    y: 235.15,
    width: 16.96,
    height: 64.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 525.18,
    y: 256.13,
    width: 5.8,
    height: 28.11,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540.35,
    y: 235.15,
    width: 16.96,
    height: 64.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 545.71,
    y: 256.13,
    width: 5.8,
    height: 28.11,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560.88,
    y: 235.15,
    width: 16.96,
    height: 64.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 566.23,
    y: 256.13,
    width: 5.8,
    height: 28.11,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.66,
    y: 319.94,
    width: 16.96,
    height: 64.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.01,
    y: 340.91,
    width: 5.8,
    height: 28.11,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.19,
    y: 319.94,
    width: 16.96,
    height: 64.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.54,
    y: 340.91,
    width: 5.8,
    height: 28.11,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 437.71,
    y: 319.94,
    width: 16.96,
    height: 64.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.07,
    y: 340.91,
    width: 5.8,
    height: 28.11,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.24,
    y: 319.94,
    width: 16.96,
    height: 64.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 463.6,
    y: 340.91,
    width: 5.8,
    height: 28.11,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 478.77,
    y: 319.94,
    width: 16.96,
    height: 64.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 484.12,
    y: 340.91,
    width: 5.8,
    height: 28.11,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499.3,
    y: 319.94,
    width: 16.96,
    height: 64.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504.65,
    y: 340.91,
    width: 5.8,
    height: 28.11,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 519.82,
    y: 319.94,
    width: 16.96,
    height: 64.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 525.18,
    y: 340.91,
    width: 5.8,
    height: 28.11,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540.35,
    y: 319.94,
    width: 16.96,
    height: 64.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 545.71,
    y: 340.91,
    width: 5.8,
    height: 28.11,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560.88,
    y: 319.94,
    width: 16.96,
    height: 64.71,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 566.23,
    y: 340.91,
    width: 5.8,
    height: 28.11,
    style: {
      fill: "none",
      stroke: "#7d8488",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9669537194070301px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-77"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M629.58,234.86s0-5.4,7.56-13S649.57,210,649.57,210s3.79,12.43-3.24,20a133.08,133.08,0,0,1-16.75,14.59Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.56,268.61s0-5.4,7.56-13,12.44-11.89,12.44-11.89,3.78,12.43-3.25,20a133.08,133.08,0,0,1-16.75,14.59Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.05,244.07s-.57-5.38-8.89-12.1-13.62-10.51-13.62-10.51-2.45,12.76,5.34,19.54a133.4,133.4,0,0,0,18.2,12.74Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.32,283.93s-1.13-5.29-10.12-11.1-14.64-9-14.64-9-1.1,12.94,7.36,18.87a132.36,132.36,0,0,0,19.44,10.76Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.83,327.39s0-5.41-7.57-13-12.43-11.89-12.43-11.89-3.78,12.44,3.24,20a132.64,132.64,0,0,0,16.76,14.59Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641,338s-.77-5.35,5.65-13.91,10.61-13.54,10.61-13.54,5.51,11.77-.37,20.26a132.61,132.61,0,0,1-14.51,16.82Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.41,369.43s0-5.4-7.56-13-12.43-11.89-12.43-11.89-3.79,12.43,3.24,20a133.08,133.08,0,0,0,16.75,14.59Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.36,397.93s1.37-5.22-4-14.46-9-14.65-9-14.65-6.81,11.07-1.93,20.17a132.82,132.82,0,0,0,12.52,18.35Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.89,233.48A157,157,0,0,0,631,250.26c3,15.45,10.47,25.42,13.46,39.38s-5.59,31.94-3.29,49.86,9.28,27.9,7.28,39.86S636,423.73,636,423.73",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9622169509432084px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 630.13,
    y1: 247.66,
    x2: 621.97,
    y2: 241.4,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9622169509432084px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 629.75,
    y1: 240.45,
    x2: 633.16,
    y2: 234.38,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9622169509432084px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644,289s-6.83-5.12-13.84-10.24",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9622169509432084px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.56,278.34s5.69-11.15,12.13-18.55",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9622169509432084px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.56,335.07A84.46,84.46,0,0,0,626,315.54",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9622169509432084px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.88,342.66a95.54,95.54,0,0,1,7.4-14c4-5.88,4.55-6.64,4.55-6.64",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9622169509432084px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.41,379.36a90.07,90.07,0,0,0-6.15-12.43,79.39,79.39,0,0,0-8-10.43",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9622169509432084px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.9,407.34s.8-6.47-2-12-6.07-12.7-7.39-15.55",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9622169509432084px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.12,307.06s.59-3.39-3.33-8.95-6.51-8.81-6.51-8.81-3.72,7.38-.13,12.89a84.1,84.1,0,0,0,8.92,11Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.57,327s.59-3.39-3.33-8.95-6.51-8.81-6.51-8.81-3.72,7.39-.13,12.89a84.1,84.1,0,0,0,8.92,11Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.83,312.78s.94-3.31,6.89-6.62,9.68-5.11,9.68-5.11.15,8.26-5.47,11.67a84.73,84.73,0,0,1-12.8,6Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.18,336.34s1.28-3.19,7.55-5.86,10.16-4.07,10.16-4.07-.72,8.24-6.66,11a84.81,84.81,0,0,1-13.36,4.64Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662,363.86s.58-3.39,6.15-7.31,9.08-6.11,9.08-6.11,1,8.21-4.2,12.19A84.89,84.89,0,0,1,661,370Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.8,370.5s1.06-3.27-2-9.34-5.19-9.64-5.19-9.64-4.73,6.78-2,12.74a85.42,85.42,0,0,0,7.27,12.13Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.3,397.84s-.39-3.42-5.73-7.66-8.72-6.61-8.72-6.61-1.49,8.13,3.5,12.41A84.75,84.75,0,0,0,652,404Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.7,389.4s.59-3.39,6.16-7.31,9.08-6.11,9.08-6.11,1,8.21-4.2,12.19a84.89,84.89,0,0,1-12.09,7.33Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.78,407.82s-.29-3.42,4.1-8.63,7.24-8.21,7.24-8.21,3.07,7.68-1,12.86A85,85,0,0,1,653.3,414Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.7,306.27a95.72,95.72,0,0,1-3.12,10.29c-3.55,9.37-9.32,14.81-12.71,23.24s0,20.63-3.35,31.63-8.84,16.48-8.89,24.2,3,29.17,3,29.17",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9622169509432084px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 677.39,
    y1: 315.03,
    x2: 683.18,
    y2: 311.99,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9622169509432084px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 678.41,
    y1: 310.55,
    x2: 676.93,
    y2: 306.37,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9622169509432084px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.22,339.44s4.84-2.46,9.79-4.91",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9622169509432084px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.52,333.13a69.21,69.21,0,0,0-5.6-12.94",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9622169509432084px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.36,368.71a53.72,53.72,0,0,1,11.28-10.66",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9622169509432084px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.7,373.32a60.47,60.47,0,0,0-3.11-9.6c-1.86-4.12-2.13-4.66-2.13-4.66",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9622169509432084px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.89,401.49s-3.84-4.71-6.23-6.47a32.69,32.69,0,0,1-4-3.52",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9622169509432084px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.63,395.63a57.26,57.26,0,0,1,5.2-7.13,50.24,50.24,0,0,1,6.13-5.67",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9622169509432084px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.3,414a14.73,14.73,0,0,1,2.58-7.28c2.38-3.14,5.19-7.31,6.33-8.95",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9622169509432084px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.37,469.54H660.3a2.36,2.36,0,0,0,2.36-2.36l7.42-46.12H620.59L628,467.18A2.36,2.36,0,0,0,630.37,469.54Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9622169509432084px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621,427.52h49.06a3.88,3.88,0,0,0,3.88-3.88h0a3.88,3.88,0,0,0-3.88-3.87H621a3.87,3.87,0,0,0-3.87,3.87h0A3.88,3.88,0,0,0,621,427.52Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9622169509432084px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 668.14,
    y1: 427.69,
    x2: 632.51,
    y2: 427.69,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9622169509432084px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 629.16,
    y1: 427.69,
    x2: 623.29,
    y2: 427.69,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9622169509432084px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-77"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M547.26,292s1.54-5.07-1.21-9.42-10.27-3.37-12.26-.09-2.8,9.75-2.8,9.75.11,5,3.93,7S547.2,295.62,547.26,292Z",
    style: {
      fill: "#c9c9c9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.79,282.5a7.89,7.89,0,0,0,1.72,5.61c2.07,2.26,5.15,3.8,8.88.27l-8.24,12.45s-8.49.61-9.14-4.41,3-6.38,3-6.38Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.37,347.63l24.47-67.54s.67,8.6,4.93,12.42,11.08,2,12.49-.5L519.1,348.48S513.29,356.81,505.37,347.63Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.51,306.45s3.47-4,2.75-9.09-8-7.27-11.16-5.09-6.54,7.76-6.54,7.76-1.94,4.61.72,8S558,309.72,559.51,306.45Z",
    style: {
      fill: "#c9c9c9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.1,292.27a7.91,7.91,0,0,0-.72,5.82c1,2.91,3.15,5.58,8,3.88l-12.61,8s-8-2.91-6.55-7.76,5.34-4.61,5.34-4.61Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.56,340.12l49.92-51.66s-2.9,8.12-.58,13.35,9.29,6.38,11.61,4.64l-48.76,40.06S502,351.73,498.56,340.12Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "492.63 378.53 522.46 376.86 523.95 326.79 486.66 328.88 492.63 378.53",
    style: {
      fill: "#c9c9c9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "518.59 377.08 548.42 375.4 549.9 325.34 512.62 327.43 518.59 377.08",
    style: {
      fill: "#707070",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 511.75,
    y: 323.99,
    width: 39.14,
    height: 6.87,
    transform: "translate(1080.12 624.61) rotate(176.79)",
    style: {
      fill: "#707070",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 484.31,
    y: 325.78,
    width: 30.18,
    height: 6.87,
    transform: "matrix(-1, 0.06, -0.06, -1, 1016.43, 629.97)",
    style: {
      fill: "#c9c9c9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.76,307l17.3-1,1.18,21a2.84,2.84,0,0,1-2.67,3h0a2.84,2.84,0,0,1-3-2.67l-1-18.35-13.13.74Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.61,433.8l.46,19.75a43.42,43.42,0,0,1-9,6.68c-4.68,2.51-10.47,3.81-12.14,4.48-3.49,1.39-4.65,3.48-2.79,4.41s39.5,0,39.5,0a12.33,12.33,0,0,0,.93-5.11c0-3.25-1.62-9.53-1.62-9.53s-.7-5.34-.7-7.2V433.34Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "490.3 434.72 490.67 439.94 505.05 438.08 505.25 433.33 490.3 434.72",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.57,464c0-3.25-1.62-9.53-1.62-9.53s-.11-.83-.24-2c-1.82,1.21-3,5-3,5l-10,.93a33.85,33.85,0,0,0-.47-3.72,1.26,1.26,0,0,0-1.16-1.2v0a54,54,0,0,1-10,7.21c-4.36,2.34-9.6,3.33-11.15,3.95-3.49,1.39-4.65,3.48-2.79,4.41s39.5,0,39.5,0A12.33,12.33,0,0,0,507.57,464Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.64,469.12a8.87,8.87,0,0,0,.64-2.09H466.57a1.31,1.31,0,0,0,.57,2.09C469,470.05,506.64,469.12,506.64,469.12Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.18,291.16s-14.69,66-15.81,70.95,2,66.81,2,66.81l-17.2,1.16-5.34-33.23,11.39-101.73Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "487.35 426.36 488.52 436.82 506.64 434.03 506.64 424.97 487.35 426.36",
    style: {
      fill: "#707070",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.21,433.8l.46,19.75s-23.66,9.76-27.14,11.16-4.65,3.48-2.79,4.41,45.5,0,45.5,0a12.33,12.33,0,0,0,.93-5.11c0-3.25-1.63-9.53-1.63-9.53s-.69-5.34-.69-7.2V433.34Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "466.21 433.8 466.58 437.52 480.4 436.96 480.85 433.33 466.21 433.8",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.17,464c0-3.25-1.63-9.53-1.63-9.53s-.1-.83-.24-2c-1.81,1.21-3,5-3,5l-10,.93a33.85,33.85,0,0,0-.47-3.72,1.26,1.26,0,0,0-1.16-1.2v0s-23.66,9.76-27.14,11.16-4.65,3.48-2.79,4.41,45.5,0,45.5,0A12.33,12.33,0,0,0,483.17,464Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.24,469.12a8.87,8.87,0,0,0,.64-2.09H436.17a1.31,1.31,0,0,0,.57,2.09C438.6,470.05,482.24,469.12,482.24,469.12Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.49,164.67c-.28,1.46-1,46.44.53,54.27s2.1,18.22.41,26.58-11.72,32.7-11.72,32.7-4-43.33-4.58-54.08,1.31-15.17,3.39-22.84S533.49,164.67,533.49,164.67Z",
    style: {
      fill: "#7E57C2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519,239.91a19.45,19.45,0,0,0,12.61.37",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.13,235.59s8.6-.48,15.55-4.83",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.82,228.72A26.54,26.54,0,0,0,533,226.18",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.62,291.8s1.61,33,2.28,44.8,4.24,51.65,5.17,61.88,3.49,31.6,3.49,31.6l20.91-.46,4.19-33.23,6.3-50.87,6.27-50.16Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "486.14 402.44 489.73 350.75 499.78 306.95",
    style: {
      fill: "none",
      stroke: "#707070",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.21 189.84 417.21 221.86 441.51 199.49 405.76 168.66 377.21 189.84",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "417.21 221.86 418.39 223.01 442.22 201.68 441.51 199.49 417.21 221.86",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 381.37,
    y1: 189.98,
    x2: 378.37,
    y2: 192.94,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9590003490447998px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 384.49,
    y1: 192.7,
    x2: 381.49,
    y2: 195.66,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9590003490447998px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 387.61,
    y1: 195.42,
    x2: 384.61,
    y2: 198.38,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9590003490447998px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 390.73,
    y1: 198.13,
    x2: 387.73,
    y2: 201.09,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9590003490447998px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 393.85,
    y1: 200.85,
    x2: 390.85,
    y2: 203.81,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9590003490447998px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 396.98,
    y1: 203.57,
    x2: 393.97,
    y2: 206.53,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9590003490447998px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400.1,
    y1: 206.29,
    x2: 397.1,
    y2: 209.25,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9590003490447998px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.22,
    y1: 209.01,
    x2: 400.22,
    y2: 211.97,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9590003490447998px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 406.34,
    y1: 211.73,
    x2: 403.34,
    y2: 214.69,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9590003490447998px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 409.46,
    y1: 214.45,
    x2: 406.46,
    y2: 217.41,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9590003490447998px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 412.58,
    y1: 217.16,
    x2: 409.58,
    y2: 220.12,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9590003490447998px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 415.7,
    y1: 219.88,
    x2: 412.7,
    y2: 222.84,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9590003490447998px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.35 179.61 420.89 217.46 448.37 199.13 417.84 163.13 386.35 179.61",
    style: {
      fill: "#7E57C2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "420.89 217.46 421.88 218.78 448.73 201.41 448.37 199.13 420.89 217.46",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 390.44,
    y1: 180.4,
    x2: 387.01,
    y2: 182.85,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9590003490447998px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 393.1,
    y1: 183.57,
    x2: 389.67,
    y2: 186.02,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9590003490447998px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 395.76,
    y1: 186.74,
    x2: 392.33,
    y2: 189.19,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9590003490447998px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 398.42,
    y1: 189.91,
    x2: 394.99,
    y2: 192.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9590003490447998px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 401.08,
    y1: 193.08,
    x2: 397.66,
    y2: 195.53,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9590003490447998px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.74,
    y1: 196.25,
    x2: 400.32,
    y2: 198.71,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9590003490447998px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 406.4,
    y1: 199.42,
    x2: 402.98,
    y2: 201.88,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9590003490447998px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 409.06,
    y1: 202.59,
    x2: 405.64,
    y2: 205.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9590003490447998px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 411.72,
    y1: 205.76,
    x2: 408.3,
    y2: 208.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9590003490447998px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 414.38,
    y1: 208.93,
    x2: 410.96,
    y2: 211.39,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9590003490447998px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 417.04,
    y1: 212.1,
    x2: 413.62,
    y2: 214.56,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9590003490447998px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 419.7,
    y1: 215.27,
    x2: 416.28,
    y2: 217.73,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9590003490447998px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.46,151.51s-4.88-.14-11.19,3.71-9.27,4.71-9.36,7.27-2.38,28.47-3.48,37.85S440.69,222.54,439,225s-3.66,5.33-3.66,5.33l-15.21-14s-1.22-5.05-3.94-7.92a24.92,24.92,0,0,0-4.89-4.15s.68-8.65-.12-10.47-5.35-4.12-5.22-1.8.61,10.9-.17,13.51-1.82,5-1.82,5L394.44,203a15.14,15.14,0,0,0,1.16,4.12c1.09,2.73,3.58,9.81,3.58,9.81s13.91,3.18,14.63,3.6,11.11,19.63,15,26.39,10.15,10.84,14.71,9.19S451,247.8,451,247.8s-3,16.69-4.54,22.83-1,11,2.84,13.34,26.87,5.94,43.11,5,29.73-5.16,31-8.25a14.23,14.23,0,0,0,1-7c-.12-2.09-1.35-19.94-1.35-19.94s-.71-33.48.83-39.15,8.49-31.2,8.67-36.33,3.24-21.13.4-26.09-14-12.72-19-15-2.7-2.41-8.5-2.09-26.74,8.71-31.27,11.06S470.46,151.51,470.46,151.51Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451,78.82s-7.11,6-5.85,7.77,2,1.75,2,1.75-2.93,9.94-2.25,13.86,4.47,9.06,4.57,10.92-4.2,8.15-3,9.47,4.05,1.64,4.05,1.64,10.08,17.82,13.32,17.64,6.51-4.32,6.51-4.32l4.48,5.1,29.37-15.84s-5.42-13.66-7.6-19.36-1.14-20.19-5.3-28.1S474,68.92,464.39,72.25,451,78.82,451,78.82Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.22,111.57c.41,1.15.41,2.2,0,2.35s-1.1-.65-1.51-1.8-.41-2.2,0-2.35S453.8,110.42,454.22,111.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.79,105.47s1.44-3.34,4.33-1.63",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.13,88.34s-5.34-3.89-9.61,2.87",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.64,88.61s-4.63.49-6.45-2.89,2.41-6.89,8.52-10,14.34-5.7,21.57-5.4,13.63,2.26,17.38,6.94,4,13,4.21,17,9.72,11.33,12.48,14.9,1.12,11.81-.4,13.75-5.15,3.55-5.15,3.55l-.22-3.94a16.86,16.86,0,0,1-3.25,4.37,23.82,23.82,0,0,1-5.42,2.86l-.29-5.1s.14,2.55-3,5.28-9.53,4.49-9.53,4.49S482.7,125,481,120s-3.6-10.27-6.24-11.75a11.11,11.11,0,0,0-5.43-1.33s6.57,13.37,6.4,18.73-5.56,12.88-5.56,12.88-3.3,3.44-6.33,3.38-6.86-6.13-9.18-10.19-4.14-7.45-4.14-7.45,3.4-1.59,6-1a60.19,60.19,0,0,1,8.33,3.26s3-1.1,3.13-6.46a44.24,44.24,0,0,0-2.7-15c-1.07-2.51-8.41-4.65-9.92-6.66s.66-9.12.66-9.12Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.71,80c-.73.63-6.32,7.8-4.59,13.76s8.35,7.67,12.5,7,13.49-8.44,8.66-15.62S501.59,75.75,496.71,80Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.37,108.45s-.18-7.43,2.08-8.49,5.9,1.3,5,6.7a19.92,19.92,0,0,1-3.7,8.82Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "461.56 425.67 461.79 435.43 482.47 434.5 482.71 426.13 461.56 425.67",
    style: {
      fill: "#707070",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.71,278.22s7.23-17.55,10.45-28c-5.95-.15-10.73-3.26-13.42-5.49C521.07,260.39,522.71,278.22,522.71,278.22Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.38,281l1.55,15s18.73,6.17,33.07,4.67,38.23-7.27,39.57-8.27.14-14.21.14-14.21-20.3,7.42-42.27,5.86-32.65-5.38-32.65-5.38Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.62,291.52c15.65-1.51,26.91-7.58,32.35-9.89,0-.33,0-.64-.07-.93-1.33-.17-3.41-.41-6.11-.66-7.61,2.09-21.6,5.09-36.35,4-22-1.56-32.65-5.38-32.65-5.38l.59,2.29.55,5.28C453.49,288.32,475.14,293,490.62,291.52Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.47,178.29c.18-5.13,3.24-21.13.4-26.09s-14-12.72-19-15-2.7-2.41-8.5-2.09-26.74,8.71-31.27,11.06-6,4.82-6,4.82-2.55.37-8.86,4.22-9.27,4.71-9.36,7.27-2.38,28.47-3.48,37.85S440.69,222.54,439,225s-3.66,5.33-3.66,5.33l-2.2-2c-1.39.65-5.73,2.92-7.09,6.5a17,17,0,0,0-.7,6c1.37,2.47,2.59,4.67,3.48,6.21,3.87,6.77,10.15,10.84,14.71,9.19S451,247.8,451,247.8s-3,16.69-4.54,22.83-1,11,2.84,13.34,26.87,5.94,43.11,5,29.73-5.16,31-8.25a14.23,14.23,0,0,0,1-7c-.12-2.09-1.35-19.94-1.35-19.94s-.71-33.48.83-39.15S532.29,183.42,532.47,178.29Z",
    style: {
      fill: "#7E57C2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.14,243.72c.17-5.36,7.16-13.43,7.16-13.43s-4.76,14.69-1.92,19.65",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.3,230.29s2.11,16.87,7.48,21.22",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.3,
    y1: 243.75,
    x2: 479.6,
    y2: 235.72,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 488.01,
    y1: 232.22,
    x2: 480.41,
    y2: 241.96,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 501.93,
    y1: 223.06,
    x2: 483.96,
    y2: 242.92,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 499.68,
    y1: 232.73,
    x2: 493.11,
    y2: 240.08,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512,157.33s3.33,5.4,1,17.4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.77,166.89s0,8.84-3.75,16",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451,247.8s9.43-12.58,13.39-23.26,5.54-26.51,10.28-33.64",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 470.67,
    y1: 200.8,
    x2: 478.58,
    y2: 192.49,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.75,228.89s-3.95,13.46-7.91,18.6a29.77,29.77,0,0,0-5.15,10.29l1.26-10S457.21,238.78,462.75,228.89Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.57,125s-20.4,9-25.52,12.83-8.74,6.78-9.53,8.68-6.14,7.4-6.14,7.4,19.8-9.79,30.67-14.13,17.74-4.95,17.74-4.95S508.72,127.72,502.57,125Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9795001745223999px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-77"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.28,99.15A29.33,29.33,0,0,1,131,86c17.7.57,22,20,21.41,25.69a27.45,27.45,0,0,1-2.56,9.42l-7.71-6.56a53.17,53.17,0,0,1,12,18.61c4.28,11.42,2.22,26.21-3.2,29.63s-9.14,2-9.14,2l.57-7.71s-5.14,9.14-13.7,10.85-33.12,2.86-36.83-1.43a21.12,21.12,0,0,1-4.57-9.13l-.57,7.42s-7.71-5.71-8-12.27,3.71-15.71,5.71-20.56,3.42-7.42,4-14.84-.29-11.42,4.85-16.28S105.28,99.15,105.28,99.15Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9359187562324296px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.73 316.14 175.14 360.56 144.82 351.76 162.29 310.18 195.73 316.14",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9359187562324296px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.14 360.56 174.61 362.05 145.15 353.94 144.82 351.76 175.14 360.56",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9359187562324296px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 192.23,
    y1: 318.03,
    x2: 196.05,
    y2: 319.29,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.8718375124648592px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190.71,
    y1: 321.69,
    x2: 194.54,
    y2: 322.94,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.8718375124648592px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.2,
    y1: 325.34,
    x2: 193.03,
    y2: 326.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.8718375124648592px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 187.69,
    y1: 328.99,
    x2: 191.51,
    y2: 330.25,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.8718375124648592px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 186.18,
    y1: 332.65,
    x2: 190,
    y2: 333.9,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.8718375124648592px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 184.66,
    y1: 336.3,
    x2: 188.49,
    y2: 337.56,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.8718375124648592px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 183.15,
    y1: 339.96,
    x2: 186.98,
    y2: 341.21,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.8718375124648592px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 181.64,
    y1: 343.61,
    x2: 185.46,
    y2: 344.87,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.8718375124648592px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180.12,
    y1: 347.26,
    x2: 183.95,
    y2: 348.52,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.8718375124648592px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 178.61,
    y1: 350.92,
    x2: 182.44,
    y2: 352.17,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.8718375124648592px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 177.1,
    y1: 354.57,
    x2: 180.93,
    y2: 355.83,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.8718375124648592px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 175.59,
    y1: 358.23,
    x2: 179.41,
    y2: 359.48,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.8718375124648592px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.56 311.28 170.12 358.36 138.8 354.38 149.6 310.59 183.56 311.28",
    style: {
      fill: "#7E57C2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9359187562324296px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.12 358.36 169.83 359.91 139.47 356.48 138.8 354.38 170.12 358.36",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9359187562324296px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180.39,
    y1: 313.69,
    x2: 184.37,
    y2: 314.34,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.8718375124648592px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 179.47,
    y1: 317.54,
    x2: 183.44,
    y2: 318.18,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.8718375124648592px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 178.54,
    y1: 321.38,
    x2: 182.51,
    y2: 322.03,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.8718375124648592px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 177.61,
    y1: 325.23,
    x2: 181.59,
    y2: 325.87,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.8718375124648592px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 176.69,
    y1: 329.07,
    x2: 180.66,
    y2: 329.72,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.8718375124648592px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 175.76,
    y1: 332.92,
    x2: 179.73,
    y2: 333.56,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.8718375124648592px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 174.83,
    y1: 336.76,
    x2: 178.81,
    y2: 337.41,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.8718375124648592px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 173.9,
    y1: 340.6,
    x2: 177.88,
    y2: 341.25,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.8718375124648592px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 172.98,
    y1: 344.45,
    x2: 176.95,
    y2: 345.09,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.8718375124648592px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 172.05,
    y1: 348.29,
    x2: 176.03,
    y2: 348.94,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.8718375124648592px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 171.12,
    y1: 352.14,
    x2: 175.1,
    y2: 352.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.8718375124648592px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 170.2,
    y1: 355.98,
    x2: 174.17,
    y2: 356.63,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.8718375124648592px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.97 385.23 164.52 385.23 168.09 337.53 132.4 337.53 135.97 385.23",
    style: {
      fill: "#707070",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9359187562324296px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.81 385.23 189.35 385.23 192.92 337.53 157.24 337.53 160.81 385.23",
    style: {
      fill: "#c9c9c9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9359187562324296px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.38,
    y: 335.25,
    width: 37.4,
    height: 6.57,
    transform: "translate(350.16 677.06) rotate(180)",
    style: {
      fill: "#c9c9c9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9359187562324296px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.12,
    y: 335.25,
    width: 28.83,
    height: 6.57,
    transform: "translate(289.07 677.06) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9359187562324296px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.38,318.12h16.56v20.13a2.72,2.72,0,0,1-2.72,2.71h0a2.72,2.72,0,0,1-2.71-2.71V320.69H159Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9359187562324296px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.21,181.82s5,5.55,5,19,.85,40.54,1.42,44.25,8.28,27.41,8.57,36,0,26,0,28.26.28,12.56-1.43,14-6.57,1.14-8.28.28-.28-15.41-.28-18-9.14-40.26-9.71-46.25S143,236.75,143,227.62s-1.35-49.21-1.35-49.21A59.73,59.73,0,0,1,154.21,181.82Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9359187562324296px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.8,310.7s2,8.56,2.28,10-4,3.42-5.42,5.42-4,2.29-2.57-.57,2-3.71,2-3.71a21.77,21.77,0,0,1-1.14-6.57",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9359187562324296px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139,423.35l-1.72,31a132.7,132.7,0,0,0,11.55,7.42c4.83,2.58,12.07,5,11.9,6.38s-30.86,0-30.86,0-1.73-.35-2.24-3.45.86-6.73.86-9.31-3.11-32.24-3.11-32.24Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9359187562324296px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.96 428.13 138.32 427.92 138.53 424.99 125.55 424.78 125.96 428.13",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9359187562324296px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.94,457.66a2.53,2.53,0,0,1,2.36-1.87c2.36,1.63,6.35,4.3,9.53,6,4.83,2.58,12.07,5,11.9,6.38s-30.86,0-30.86,0-1.73-.35-2.24-3.45a13.64,13.64,0,0,1,.15-4.31h8.64S136.59,459.56,136.94,457.66Z",
    style: {
      fill: "#7E57C2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9359187562324296px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.63,421.52l-5.29,30.63a135.06,135.06,0,0,0,10.62,8.7c4.5,3.12,11.42,6.35,11.09,7.7S94.39,465,94.39,465s-1.67-.54-1.83-3.69,1.63-6.58,1.93-9.14.63-32.39.63-32.39Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9359187562324296px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.98 428.34 94.98 430.64 106.49 432.11 107.12 428.55 95.19 427.29 94.98 428.34",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9359187562324296px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.62,455.37a2.52,2.52,0,0,1,2.56-1.58c2.16,1.89,5.82,5,8.78,7.06,4.5,3.12,11.42,6.35,11.09,7.7-.17.68-5,1.55-12.58.49a165,165,0,0,1-18.08-4s-1.67-.54-1.83-3.69a13.49,13.49,0,0,1,.65-4.26l8.58,1S102.06,457.21,102.62,455.37Z",
    style: {
      fill: "#7E57C2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9359187562324296px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.43,181.66s-5.43.52-10.06,6.69S53.92,230.6,53,234.62s1,9.75,5.62,10.26,11.44-3,15-10.73S97.87,204.3,97.87,204.3,96.89,186.28,90.43,181.66Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9359187562324296px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.69,156s-.28,13.71,1.43,16.27,12.85,4.86,17.13,6.29,9,2.5,9,3.3c-.18,2.27-5.25,35.24-5.82,42.66S147,237.33,147,237.33s16.27,24.55,17.7,40c.9,9.71.75,26.76-4,50.25-2.59,12.84-12.56,49.1-12.84,56.24s.28,40.25.28,40.25-12.84,2.57-18.27,2.29a46.66,46.66,0,0,1-7.71-.86l-.28,2s-7.71,2.28-19.7,1.43-15.42-3.43-15.42-3.43-2-33.69,0-50.81,5.71-29.41,5.71-39.69-9.13-41.68-8.85-61.38,17.13-35.11,17.13-35.11L90.43,181.66s14-4.29,17.13-6.57S111.27,154,111.27,154Z",
    style: {
      fill: "#7E57C2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9359187562324296px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.73,287l-7.55,5.49s-1.37,36-3.09,55.57-5.83,56.94-3.77,72.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9359187562324296px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.21 288.91 127.36 314.16 128.18 292.46 133.21 288.91",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9359187562324296px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140.06,
    y1: 227.97,
    x2: 128.22,
    y2: 240.32,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9359187562324296px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.52,
    y1: 235.69,
    x2: 128.22,
    y2: 243.41,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9359187562324296px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.41,216.2l-19.57-39.67a16.13,16.13,0,0,0,2.72-1.44c3.14-2.28,3.71-21.13,3.71-21.13l15.42,2s-.28,13.71,1.43,16.27c.95,1.43,4.8,2.77,8.77,3.92Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9359187562324296px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,159c.21-2.91.27-5,.27-5l15.42,2s-.07,3.3.06,7C121.28,164.78,115.71,163.79,111,159Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9359187562324296px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.14,129.7s1.71-12.85,5.71-19.7,12.56-4.85,16-2.57,8.85,14.56,12,22.55,4.56,12.56,4.56,12.56-5,10.4-11.7,14.56c-7.18,4.45-15,4.27-21.13-2.85a33,33,0,0,1-5.14-8.28s-7.13-2.28-8.85-8.28-.28-9.14,2.57-10S102.14,129.7,102.14,129.7Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9359187562324296px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.41,125.41a12.71,12.71,0,0,0,2,7.43c2.28,3.14.28,6.56-3.72,5.71",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9359187562324296px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.41,143.69s-9.71,4.56-14.28-4.57",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9359187562324296px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.84,130c0,1.26.52,2.29,1.15,2.29s1.14-1,1.14-2.29-.51-2.28-1.14-2.28S113.84,128.72,113.84,130Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 128.97,
    cy: 129.98,
    rx: 1.14,
    ry: 2.28,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.27,120s-3.14-2.28-6.57.86",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9359187562324296px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.55,120.56a4.79,4.79,0,0,1,5.42-1.14",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9359187562324296px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.27 193.7 110.54 230.73 104.16 228.88 102.92 195.76 108.27 193.7",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9359187562324296px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.59,201.06A13.33,13.33,0,0,0,114,197c1.9-2.72,0-2.72,0-2.72l-6,2.72Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9359187562324296px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.66,200s3.27-6.25,5.44-11.42,7.08-7.61,9.52-6.53,3,2.45,6.26,2.72,6.25-.54,6.25.82a3.72,3.72,0,0,1-3,3.26l-1.63.28s4.9-.28,5.17,1.63,0,10.06-1.09,10.33-19.31,0-19.31,0-9.79,20.67-13.6,28-5.17,8.39-7.75,11.74c-4.81,6.26-20.72,7.85-14.19-8.47,1.92-4.81,5.72-8.78,13.24-16.87C74.05,207.86,81.66,200,81.66,200Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9359187562324296px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 106.14,
    y1: 188.82,
    x2: 107.23,
    y2: 200.52,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9359187562324296px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.45,187.19c3,1.63,10.06,1.91,10.06,1.91",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9359187562324296px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.42 189.64 101.79 224.72 91.18 223.09 96.35 188.55 103.42 189.64",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9359187562324296px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.68,220.37s29.1,3,31.28,3.27,5.17,2.17,5.17,6.8.27,46-.28,52.22-7.34,10.06-17.67,12S67.79,293,64.53,289.46s-3.81-7.35-3.81-10.88S64,234,65.35,227.72A9.06,9.06,0,0,1,75.68,220.37Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9359187562324296px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.31,227.17s1.09,2.45-1.36,5.17a7,7,0,0,1-5.44,2.45s-1.9,12.24-1.9,20.4,2.72,20.4-.55,25.56-23.66,9.52-41.34-2.17",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9359187562324296px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.68 220.37 78.19 216.78 89.62 218.29 90.27 221.96 75.68 220.37",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9359187562324296px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.35,227.72a9.06,9.06,0,0,1,10.33-7.35s29.1,3,31.28,3.27a5.81,5.81,0,0,1,4.45,3.33l-.1.2s-5.44,2.45-6.8,12.51,3.26,17.41-4.62,23.67-35.63-.82-37.26-1.91a.84.84,0,0,0-.7-.1C63,248.08,64.52,231.51,65.35,227.72Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9359187562324296px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.63,261.44a.84.84,0,0,0-.7-.1c.1-1.31.21-2.66.33-4a98.62,98.62,0,0,0,18,4.67c11.16,1.63,18.77-1.36,19.86-6s0-16.59,2.72-24.2a10.91,10.91,0,0,1,6.68-7.09,5.94,5.94,0,0,1,1.85,2.26l-.1.2s-5.44,2.45-6.8,12.51,3.26,17.41-4.62,23.67S64.26,262.53,62.63,261.44Z",
    style: {
      fill: "#7E57C2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9359187562324296px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.41,275.86h0a2.47,2.47,0,0,0,3.13-2.48V257.33a4.05,4.05,0,0,0-3.13-3.78h0A2.48,2.48,0,0,0,89.28,256v16.05A4.05,4.05,0,0,0,92.41,275.86Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9359187562324296px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.55 266.02 95.53 267.26 95.53 260.73 89.55 259.49 89.55 266.02",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9359187562324296px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69,272.59h0a2.74,2.74,0,0,0,3.13-2.77v-16A3.6,3.6,0,0,0,69,250.29h0a2.74,2.74,0,0,0-3.13,2.78v16.05A3.59,3.59,0,0,0,69,272.59Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9359187562324296px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.16 263.03 72.14 263.7 72.14 257.17 66.16 256.5 66.16 263.03",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9359187562324296px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.21,234.55c-.19,2,2,3.91,5,4.18s5.48-1.15,5.67-3.19-2-3.91-5-4.18S76.4,232.52,76.21,234.55Z",
    style: {
      fill: "#7E57C2"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-77"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229,389.37s-.87,10.45,1.09,15.46,4.14,10.24,3.92,18.3-2.61,36.17-2.61,37.47.87,3.93.87,5.89a4.51,4.51,0,0,1-1.09,3.05H208.51s-2.18-.88-1.09-2,7-2.4,9.59-5.45,4.14-5.45,4.14-8.72.43-16.12,0-19.82-6.54-19.17-7.63-28.1-1.3-17.65-1.3-17.65Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9580180044641367px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,389.37s-.2,2.41-.19,5.47a76.73,76.73,0,0,1-16.25-.06c-.26-4.1-.33-6.94-.33-6.94Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9580180044641367px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.51,469.54s-2.18-.88-1.09-2,7-2.4,9.59-5.45a17.84,17.84,0,0,0,3.64-5.7l.06,0a3.5,3.5,0,0,1,2.84,2.18,11.4,11.4,0,0,1,.43,4.14l7.53-1.1a32,32,0,0,1,.75,4.81,4.51,4.51,0,0,1-1.09,3.05Z",
    style: {
      fill: "#7E57C2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9580180044641367px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.28,389.37s-.87,10.45,1.09,15.46,2.54,10.24,2.32,18.3-2.62,36.17-2.62,37.47.87,3.93.87,5.89a4.53,4.53,0,0,1-1.08,3.05H224.2s-2.18-.88-1.09-2,7-2.4,9.59-5.45,4.13-5.45,4.13-8.72.44-16.12,0-19.82-6.53-19.17-7.62-28.1-1.31-14.82-1.31-14.82Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9580180044641367px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.09,393.68c-3.54,1.12-11,3-17.86,2.14-.26-3.26-.33-5.15-.33-5.15l18.38-1.3S246.13,391.19,246.09,393.68Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9580180044641367px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.2,469.54s-2.18-.88-1.09-2,7-2.4,9.59-5.45a17.8,17.8,0,0,0,3.63-5.7l.07,0a3.48,3.48,0,0,1,2.83,2.18,11.52,11.52,0,0,1,.44,4.14l7.52-1.1a30.76,30.76,0,0,1,.75,4.81,4.53,4.53,0,0,1-1.08,3.05Z",
    style: {
      fill: "#7E57C2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9580180044641367px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249,334.25l8.06,53.81a103,103,0,0,1-25.27,5.23c-14.16,1.09-17.86.65-17.86.65l-.44-3.05s-8.93-.22-12.63-.87a54.85,54.85,0,0,1-5.88-1.31l10.45-55.33,43.14-2.83Z",
    style: {
      fill: "#7E57C2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9580180044641367px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,382.83a84.4,84.4,0,0,1-42.7,3.27",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9580180044641367px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 210.93,
    y1: 355.15,
    x2: 210.69,
    y2: 351.89,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9580180044641367px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 213.52,
    y1: 390.89,
    x2: 211.22,
    y2: 359.21,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9580180044641367px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.09,384.79s-8.93.44-16.78-2.61",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9580180044641367px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 228.05,
    y1: 337.83,
    x2: 230.06,
    y2: 355.51,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9580180044641367px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 227.24,
    y1: 339.84,
    x2: 226.44,
    y2: 353.9,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9580180044641367px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 206.36,
    y1: 339.04,
    x2: 206.76,
    y2: 355.51,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9580180044641367px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 204.75,
    y1: 343.86,
    x2: 202.74,
    y2: 353.5,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9580180044641367px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.45,315.25,265.51,305s5.91,12.23,6.5,14,2.37,35.49,2.37,36.08,4.13,10.51,4.13,10.51,1.67,5.26,1.69,5.42a47.58,47.58,0,0,1,.49,5.84c0,.6.55,5.82-.73,4.91-.38-.27-.49-1.64-.6-2.07-.26-1-.53-1.91-.79-2.87-.41-1.52-1.26-3.36-1.34-4.94l.54,10.37a1,1,0,0,1-.88,1,1,1,0,0,1-1-.76s-2.14-10.05-2.17-10.05q.15,3.84.29,7.68c0,.76.59,2.89-.67,2.54-.7-.2-.69-.89-.84-1.51l-.75-3.25c-.38-1.59-.75-3.18-1.12-4.77h0c-.36.08-.07,3.31-.06,3.61,0,1,.23,2,.28,3,0,.44-.06,2.15-.61,2.3-1.09.29-1.1-2.72-1.18-3.28-.23-1.71-.36-3.44-.71-5.13a8.31,8.31,0,0,1-.16,3.61c-.2.85-1.09,2.7-1.69.89a6.52,6.52,0,0,1,0-1.65c0-1,0-2,0-3,0-.34.81-5.79,1-7.18.07-1.12.33-3.64.49-4.32a32.78,32.78,0,0,0,.13-7.13L260.77,321Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9580180044641367px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.03 306.76 267.67 310.1 258.43 318.22 257.07 317.09 266.03 306.76",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.26,373.68a23.27,23.27,0,0,1-.51-5.18",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9580180044641367px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.4,306.67l-7.19,17.91L184,347.23s-4.74,8.6-4.74,10.71a91.84,91.84,0,0,0,.88,9.48c.17.52.88,1.23,1.4,1.05s.53-.18.53-1.05v-4c0-.7.18-2.28.18-2.28s1.75,4.91,2.63,5.44a5.7,5.7,0,0,0,2.11,1c.52,0,.52-1,.52-1l-.88-2.11,1.76,2.11s1.76,0,1.76-.53-1.23-1.58-1.23-1.58l-.53-1.75,1.58.7s1.93.17,1.93-.35S191,362,191,362l-1.05-.7s-1.23-1.58-1.23-2.28a15.14,15.14,0,0,1,.88-4,11.8,11.8,0,0,0,1.4-4.21v-4s13-14,14.93-17,6.14-20,6.14-20Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9580180044641367px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.61 308.06 200.69 311.23 207.01 313.71 207.8 309.67 201.61 308.06",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.83,349.16s-.52,3.51-1.23,4.56a6.22,6.22,0,0,1-2.1,1.76v7.9s-1.93.88-2.11-.7-1-7.9-1-7.9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9580180044641367px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.56,263.87c.94.14,15.74,5,18.6,8.11s21.23,32.21,21.23,32.21l-16.22,17.65-3.34-3.34s1.67,14.31,1,15.74-30.54,3.82-37.45,2.87-7.88-1.91-7.88-4.06,3.34-23.38,3.34-23.38l-9.06-2.86s8.11-22.66,11.93-31.25S223.55,263.16,228.56,263.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.16,281.39a8.28,8.28,0,0,1-5.73-2.22,7.49,7.49,0,0,0-10.17,0,8.5,8.5,0,0,1-11.46,0,7.49,7.49,0,0,0-10.17,0,9.41,9.41,0,0,1-3.25,1.87c.19-.45.36-.89.54-1.32a11.3,11.3,0,0,0,2.07-1.38,8.53,8.53,0,0,1,11.46,0,7.45,7.45,0,0,0,10.16,0,8.53,8.53,0,0,1,11.46,0,7.33,7.33,0,0,0,5.09,2,6.66,6.66,0,0,0,3.34-.8l.59.88A7.65,7.65,0,0,1,249.16,281.39Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.55,333.94a7.91,7.91,0,0,0,1.36.12,7.3,7.3,0,0,0,5.08-2,8.53,8.53,0,0,1,11.46,0,7.45,7.45,0,0,0,10.16,0,8.53,8.53,0,0,1,11.46,0,7.33,7.33,0,0,0,5.09,2c.25,0,.47,0,.7,0a1.71,1.71,0,0,1-.07.21c-.11.23-.93.47-2.26.73a8.87,8.87,0,0,1-4.1-2.07,7.46,7.46,0,0,0-10.17,0,8.53,8.53,0,0,1-11.46,0,7.46,7.46,0,0,0-10.17,0,8.25,8.25,0,0,1-5.72,2.21c-.26,0-.49,0-.72,0A2.18,2.18,0,0,1,204.55,333.94Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.41,272.27a8.94,8.94,0,0,1-4-2,7.46,7.46,0,0,0-10.17,0,8.5,8.5,0,0,1-11.46,0,7.3,7.3,0,0,0-5.08-2c-.16,0-.3,0-.45,0,.45-.37.9-.71,1.36-1a8.46,8.46,0,0,1,4.82,2.17,7.45,7.45,0,0,0,10.16,0,8.39,8.39,0,0,1,5.47-2.21c3.88,1.55,7.76,3.37,9.08,4.8Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.89,288.13a8.5,8.5,0,0,1-11.46,0,7.46,7.46,0,0,0-10.17,0,8.5,8.5,0,0,1-11.46,0,7.46,7.46,0,0,0-10.17,0,8.25,8.25,0,0,1-5.72,2.22,9.54,9.54,0,0,1-1.1-.07l.39-1c.23,0,.46,0,.71,0a7.34,7.34,0,0,0,5.08-2,8.5,8.5,0,0,1,11.46,0,7.48,7.48,0,0,0,10.16,0,8.5,8.5,0,0,1,11.46,0,7.49,7.49,0,0,0,10.17,0,11.64,11.64,0,0,1,2.35-1.54l.59.9A10.19,10.19,0,0,0,254.89,288.13Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.43,323.94a7.49,7.49,0,0,0-10.17,0,8.5,8.5,0,0,1-11.46,0,7.49,7.49,0,0,0-10.17,0,8.25,8.25,0,0,1-5.72,2.22c-.21,0-.4,0-.59,0l.15-1,.44,0a7.3,7.3,0,0,0,5.08-2,8.5,8.5,0,0,1,11.46,0,7.45,7.45,0,0,0,10.16,0,8.5,8.5,0,0,1,11.46,0,7.33,7.33,0,0,0,5.09,2l.35,0,.09,1.05-.44,0A8.28,8.28,0,0,1,243.43,323.94Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.34,313a7.3,7.3,0,0,0-5.08,2,8.5,8.5,0,0,1-11.46,0,7.46,7.46,0,0,0-10.17,0,8.42,8.42,0,0,1-5,2.18c0-.36.1-.72.16-1.06a7.64,7.64,0,0,0,4.18-1.95,8.5,8.5,0,0,1,11.46,0,7.48,7.48,0,0,0,10.16,0,8.5,8.5,0,0,1,11.46,0,7.49,7.49,0,0,0,10.17,0,8.3,8.3,0,0,1,5.73-2.22,9.26,9.26,0,0,1,1.22.08l-.9,1-.32,0a7.3,7.3,0,0,0-5.08,2,8.5,8.5,0,0,1-11.46,0A7.31,7.31,0,0,0,238.34,313Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260,295.09a7.3,7.3,0,0,0-5.08,2,8.5,8.5,0,0,1-11.46,0,7.49,7.49,0,0,0-10.17,0,8.5,8.5,0,0,1-11.46,0,7.49,7.49,0,0,0-10.17,0,8.25,8.25,0,0,1-5.72,2.22,7.56,7.56,0,0,1-4.06-1c.12-.33.24-.67.37-1a6.56,6.56,0,0,0,3.69,1,7.3,7.3,0,0,0,5.08-2,8.5,8.5,0,0,1,11.46,0,7.45,7.45,0,0,0,10.16,0,8.5,8.5,0,0,1,11.46,0,7.46,7.46,0,0,0,10.17,0A8.3,8.3,0,0,1,260,294a8.87,8.87,0,0,1,2.12.25l.92,1.44A6.84,6.84,0,0,0,260,295.09Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.89,306a8.53,8.53,0,0,1-11.46,0,7.46,7.46,0,0,0-10.17,0,8.53,8.53,0,0,1-11.46,0,7.46,7.46,0,0,0-10.17,0,8.53,8.53,0,0,1-11.46,0c-.3-.24-.6-.47-.91-.69.11-.3.24-.64.37-1,.42.28.81.58,1.19.87a7.46,7.46,0,0,0,10.17,0,8.53,8.53,0,0,1,11.46,0,7.45,7.45,0,0,0,10.16,0,8.53,8.53,0,0,1,11.46,0,7.46,7.46,0,0,0,10.17,0,8.53,8.53,0,0,1,11.46,0c.35.27.69.54,1.05.78l-.72.78c-.34-.23-.66-.48-1-.72a7.45,7.45,0,0,0-10.16,0Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.56,263.87c.94.14,15.74,5,18.6,8.11s21.23,32.21,21.23,32.21l-16.22,17.65-3.34-3.34s1.67,14.31,1,15.74-30.54,3.82-37.45,2.87-7.88-1.91-7.88-4.06,3.34-23.38,3.34-23.38l-9.06-2.86s8.11-22.66,11.93-31.25S223.55,263.16,228.56,263.87Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9580180044641367px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 248.83,
    y1: 318.5,
    x2: 239.11,
    y2: 298.95,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9580180044641367px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 207.8,
    y1: 309.67,
    x2: 210.66,
    y2: 286.16,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9580180044641367px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.2,258.15c-.72,0,2.38,7.63,2.62,13.12s.24,11.93,2.86,10.73,7.64-11.21,9.31-16.7,2.14-13.83,2.14-13.83S224.5,258.63,215.2,258.15Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9580180044641367px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.13,251.47s-7.63,7.15-16.93,6.68c-.35,0,.22,1.84.92,4.38h.3c4.22,0,12.78-2.07,14.9-3.5C231.93,255,232.13,251.47,232.13,251.47Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9580180044641367px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.11,220a18.29,18.29,0,0,0-6,8.11c-1.67,5-2.86,6.68-4.53,7.16s-5.49-.24-5,2.62a12,12,0,0,0,1.91,4.77s-.48,12.17.48,14.55,7.15,2.63,11.45,2.63,13.12-2.15,15-3.58,5.72-4.53,5.48-13.12-8.59-17.65-10.73-19.08A80.58,80.58,0,0,0,217.11,220Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9580180044641367px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.8,246.94l4.3-1.91s.71,3.58-1,4.53S207.8,246.94,207.8,246.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.09,233.92c-.38,1.19-.34,2.27.1,2.41s1.11-.71,1.49-1.9.34-2.27-.1-2.41S213.48,232.73,213.09,233.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.3,231s-1.43-2.86-3.82-2.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9580180044641367px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,206.62c12.4.48,23.85,10.74,23.85,10.74,3.34-4.3,10-4.06,10-4.06,3.82-1.19,15.27,1.91,15.51,9.07S271,239.3,271,239.3a23.72,23.72,0,0,0-1.91-10.73c-2.33-4.9-12.86-10.7-13.34-11,.19.1,1.61,1,4.27,4.52,2.87,3.81,2.15,13.83,2.15,25.76s6.2,15.74,6.2,15.74a54.78,54.78,0,0,1-7.46,2.67,24.92,24.92,0,0,1-3.58-10.47,72.39,72.39,0,0,0,0,11.45c-1.5.38-3.13.76-4.93,1.13-10.49,2.14-12.88,0-12.88,0v-8.59l-2.15,8.59-10.49-.72s4.29-18.85,4.29-24.33-4.29-7.4-8.83-13.36-8.82-16.22-8.82-16.22C211.38,206.86,217.58,206.15,230,206.62Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9580180044641367px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.47,241.21l3.34,9.54s6.21-4.29,4.78-8.35S235.47,241.21,235.47,241.21Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9580180044641367px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-77"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 31.31,
    y1: 469.54,
    x2: 706.69,
    y2: 469.54,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.7682086459034991px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProvider);
export default __webpack_public_path__ + "static/media/provider.82bd1f0b741c0707951399f0b75a3672.svg";
export { ForwardRef as ReactComponent };